const TRANSLATION = {
  buyModal: {
    afterFree: 'আপনার ফ্রি ট্রায়াল শেষ হওয়ার পর',
    btn: 'ফ্রি ট্রাই করুন',
    freeTrial: '3 দিনের ফ্রি ট্রায়াল',
    monthLabel: 'মাস',
    selectLabel: 'একটি প্ল্যান নির্বাচন করুন',
    title: 'সাবস্ক্রিপশন প্ল্যান',
    yearLabel: 'বছর',
  },
  contact: {
    block1:
      'কাস্টমাইজেশন, প্রশ্ন বা পরামর্শের জন্য, দয়া করে contact@noam.tools এ আমাদের সাথে যোগাযোগ করুন। আমরা দ্রুত প্রতিক্রিয়া জানাব।',
    block2: 'গুগল অ্যাপস এক্সটেনশন স্টোরে ★★★★★ দিয়ে রেটিং দিয়ে আমাদের সমর্থন করুন।',
    block3: 'এই এক্সটেনশন শেয়ার করে অন্যদের সাহায্য করুন:',
    title: 'আমাদের সাথে যোগাযোগ করুন',
  },
  help: {
    AquickOverviewOfNoam: 'নোয়াম-এর একটি দ্রুত পর্যালোচনা',
    ChatPDF: 'চ্যাট পিডিএফ',
    ChatPDF2: 'চ্যাটপিডিএফ',
    FavoritesManagement: 'প্রিয় বস্তু ব্যবস্থাপনা',
    Fixedplugin: 'ফিক্সড প্লাগিন',
    Focusing: 'কেন্দ্রীভূত করা',
    Free: 'ফ্রি',
    FreeTrialBenefits: 'ফ্রি ট্রায়াল সুবিধা',
    GoWithWikipedia: 'উইকিপিডিয়ার সাথে যান',
    GoWithYouTube: 'YouTube দিয়ে যান',
    HoverTranslation: 'হোভার অনুবাদ',
    Howtouse: 'কিভাবে ব্যবহার করবেন',
    ImageTranslation: 'ইমেজ ট্রান্সলেশন',
    InstantTranslation: 'তাৎক্ষণিক অনুবাদ',
    Membership: 'সদস্যপদ',
    NoamHelp: 'নোয়াম আপনাকে অনুবাদ এবং সারাংশ করতে সাহায্য করে',
    PDFparallelTranslation: 'পিডিএফ প্যারালাল ট্রান্সলেশন',
    ParallelTranslation: 'সমান্তরাল অনুবাদ',
    SkipAllSteps: 'সমস্ত ধাপ এড়িয়ে যান',
    Summary: 'সারসংক্ষেপ',
    Translation: 'অনুবাদ',
    TryItForFree: 'ফ্রি তে ট্রাই করুন',
    Video: 'ভিডিও',
    VideoSummary: 'ভিডিও সারাংশ',
    VideoTranslation: 'ভিডিও অনুবাদ',
    WebSummary: 'ওয়েব সারাংশ',
    WordSelectionTranslation: 'শব্দ নির্বাচন অনুবাদ',
    benefits: 'আমাদের কাছে আপনার জন্য অপেক্ষা করছে সুবিধાઓ!',
    dayFree: '3 দিনের ফ্রি ট্রায়াল',
    done: 'সম্পন্ন',
    next: 'পরবর্তী',
    pin: 'সহজ অ্যাক্সেসের জন্য নমকে পিন করুন～～',
    planIsNotExist: 'প্ল্যানটি উপলব্ধ নেই',
    startWiki: 'এসবের শুরু করি উইকিমিডিয়ার সাথে!',
    startYoutube: 'আসুন YouTube দিয়ে শুরু করি!',
    try: 'এটা চেষ্টা করুন',
    tryNow: 'এখনই এটি চেষ্টা করুন!',
  },
  home: {
    PDFTranslate: {
      desc: 'দ্বিভাষিক অনুবাদ + চ্যাট পিডিএফ',
      sub1: {
        desc: 'দ্বিভাষিক পড়ার মাধ্যমে আপনি মূল পাঠ্য এবং অনুবাদকে পাশাপাশি তুলনা করতে পারেন, যা পড়ার দক্ষতা বাড়ায়।',
        title: 'দ্বিভাষিক পাঠ',
      },
      sub2: {
        desc: 'এআই বিশ্লেষণ ও সারাংশ করে, এবং পিডিএফ সামগ্রীর ভিত্তিতে আপনার প্রশ্নের উত্তর দিতে পারে।',
        title: 'চ্যাট পিডিএফ',
      },
      sub3: {
        desc: 'বৃহত্তর নির্ভুলতা এবং দক্ষতার জন্য AI-চালিত পিডিএফ অনুবাদ।',
        title: 'সঠিকতা এবং দক্ষতা',
      },
      title: 'পিডিএফ অনুবাদ',
    },
    aiAssistant: {
      desc: 'ওয়েব ট্রান্সলেশনকে আরও স্মার্ট ও সুবিধাজনক করা',
      panel1: {
        desc: 'দ্বিভাষিক ক্রস-রেফারেন্সিং অনুবাদ আপনাকে মূল পাঠ্যকে অনুবাদের সাথে তুলনা করতে সাহায্য করে যাতে আপনি আরও ভালোভাবে বুঝতে পারেন এবং আপনার পড়ার দক্ষতা উন্নত করতে পারেন।',
        title: 'দ্বিভাষিক অনুবাদ',
      },
      panel2: {
        left: {
          desc: 'একটি ওয়েব পৃষ্ঠা ব্রাউজ করার সময়, আপনি যে কন্টেন্টটি অনুবাদ করতে চান তার উপর হোভার করুন যাতে অনুবাদ দেখা যায়।',
          title: 'হোভার ট্রান্সলেশন',
        },
        right: {
          desc: 'একটি ওয়েব পৃষ্ঠা ব্রাউজ করার সময়, আপনি যে টেক্সটটি অনুবাদ করতে চান সেটি সিলেক্ট করুন যাতে অনুবাদ দেখা যায়।',
          title: 'টেক্সট সিলেকশন ট্রান্সলেশন',
        },
      },
      panel3: {
        one: {
          desc: 'কোনো সময়, যে কোনো জায়গায় ওয়েব পৃষ্ঠা এবং ভিডিও কন্টেন্ট অনুবাদ করুন ও সারাংশ করুন, আরও মসৃণ অভিজ্ঞতার জন্য!',
          title: 'পয়েন্ট অ্যান্ড ক্লিক',
        },
        three: {
          desc: 'এআই-চালিত বৃহৎ ভাষা মডেল উন্নত পাঠ্য অভিজ্ঞতার জন্য অনুবাদের নির্ভুলতা এবং সামঞ্জস্যতা নিশ্চিত করে।',
          title: 'এআই-চালিত',
        },
        two: {
          desc: 'বহুভাষিক সম্পূর্ণ কভারেজ, দ্বিভাষিক বাধাহীন পড়া, এক ক্লিক ট্রান্সলেশন - ভিন্নতা অনুপলব্ধ করুন!',
          title: 'আরও ব্যাপক ও সুবিধাজনক',
        },
      },
      panel4: {
        tab1: {
          desc: 'আপনার দক্ষতার বিশেষজ্ঞ - ChatGPT ব্যবহার করে, নোয়াম YouTube ভিডিও কন্টেন্টকে অনুবাদ ও সারাংশিত করে আপনার সময় সাশ্রয় করে!',
          key: 'ভিডিও',
          title: 'ভিডিও অনুবাদ ও সারাংশ',
        },
        tab2: {
          desc: 'ওয়েব ব্রাউজ করার সময় চিত্র অনুবাদ করতে ক্লিক করুন।',
          key: 'ছবি',
          title: 'ইমেজ ট্রান্সলেট',
        },
        tab3: {
          desc: 'ওয়েব পৃষ্ঠাগুলো থেকে তাত্ক্ষণিকভাবে মূল তথ্য বের করে সারাংশ প্রদান করে, আপনার পড়ার দক্ষতা বাড়ায়।',
          key: 'ওয়েব',
          title: 'ওয়েব অনুবাদ ও সারাংশ',
        },
        tag1: 'সাধারণ',
        tag2: 'দক্ষ',
        tag3: 'সমবুজে বোঝা যায়',
      },
      title: 'এআই সহকারী',
    },
    getStart: 'শুরু করুন',
    getStartedForFree: 'ফ্রি মেই শুরু করুন',
    howItWork: {
      desc: 'নোয়াম AI মডেলগুলিকে একত্রিত করে ব্যবহারকারীদের ক্রস-ল্যাঙ্গুয়েজ ওয়েব পেজ অনুবাদ ও সারাংশ, পিডিএফ ও ইমেজ অনুবাদ, ভিডিও অনুবাদ ও সারাংশের জন্য একটি বুদ্ধিমান অভিজ্ঞতা প্রদান করে।',
      title: 'এটা কিভাবে কাজ করে',
    },
    lastBlock: { desc: 'সরল পাঠের অভিজ্ঞতার জন্য উন্নত AI অনুবাদ' },
    top: {
      desc: 'নোয়াম একটি ফ্রি AI ব্রাউজার এক্সটেনশন যা আপনাকে ওয়েব পেজ, ভিডিও এবং পিডিএফ কন্টেন্ট অনুবাদ এবং সারাংশ করার জন্য সাহায্য করে।\n      নোয়াম-এ যোগ দিন এবং ম্যাজিকের অভিজ্ঞতা লাভ করুন!',
      title1: 'একটি ম্যাজিক',
      title2: 'এক ক্লিক',
    },
    userReviews: { desc: 'ক্রোম ওয়েব স্টোরে ফাইভ-স্টার রিভিউ', title: 'ব্যবহারকারীর মতামত' },
  },
  installTips: {
    btn: 'এখনই চেষ্টা করুন',
    text: 'আরও বৈশিষ্ট্য আনলক করতে "নোয়াম ব্রাউজার প্লাগইন" ইনস্টল করুন! ওয়েব ক্রস-রেফারেন্সিং,\n    ওয়েব ভিডিও সারমারাইজেশন, এবং আরও অনেক কিছু!',
  },
  locale: {
    af: 'আফ্রিকান্স',
    am: 'আমারিক',
    ar: 'আরবি',
    as: 'অসমীয়া',
    auto: 'অটো ডিটেক্ট',
    az: 'আজারবাইজানি',
    ba: 'বাশকির',
    bg: 'বুলগেরিয়ান',
    bn: 'বাংলা',
    bo: 'তিব্বতি',
    bs: 'বসনিয়ান',
    ca: 'ক্যাটালান',
    cs: 'चेक',
    cy: 'ওয়েলশ',
    da: 'ডেনিশ',
    de: 'জার্মান',
    dsb: 'লোয়ার সোরবিয়ান',
    dv: 'দিভেহি',
    el: 'গ্রীক',
    en: 'ইংরেজি',
    es: 'স্প্যানিশ',
    et: 'এস্তোনিয়ান',
    eu: 'বাস্ক',
    fa: 'ফারসি',
    fi: 'ফিনল্যান্ডি',
    fil: 'ফিলিপিনো',
    fj: 'फिजियाई',
    fr: 'ফ্রেঞ্চ',
    frCA: 'ফ্রেঞ্চ (কানাডা)',
    ga: 'আয়ারিশ',
    gl: 'গ্যালিসিয়ান',
    gom: 'কোঙ্কানি',
    gu: 'ગુજરાતી',
    ha: 'হাউসা',
    he: 'হিব্রু',
    hi: 'হিন্দি',
    hr: 'ক্রোয়েশিয়ান',
    hsb: 'উপার সোর্বিয়ান',
    ht: 'হাইতি ক্রিওল',
    hu: 'হাঙ্গেরি',
    hy: 'আর্মেনিয়ান',
    id: 'ইন্দোনেশিয়ান',
    ig: 'ইগبو',
    ikt: 'ইনুইনাকটুন',
    is: 'আইসল্যান্ডিক',
    it: 'ইতালীয়',
    iu: 'ইনুকটিটুট',
    iuLatn: 'ইনুকটিটুট (ল্যাটিন)',
    ja: 'জাপানি',
    ka: 'জর্জিয়ান',
    kk: 'কাজাখ',
    km: 'খমের',
    kmr: 'কুর্দি (উত্তরी)',
    kn: 'ಕನ್ನಡ',
    ko: 'কোরিয়ান',
    ku: 'কুর্দি (কেন্দ্রীয়)',
    ky: 'কিরগিজ',
    ln: 'লিঙ্গালা',
    lo: 'লাও',
    lt: 'লিথুয়ানিয়ান',
    lug: 'গান্ডা',
    lv: 'লাটভিয়ান',
    lzh: 'চীনা (সাহিত্যিক)',
    mai: 'মৈথিলি',
    mg: 'মালাগাসি',
    mi: 'মাওরি',
    mk: 'ম্যাসেডোনিয়ান',
    ml: 'মালয়ালম',
    mnCyrl: 'মঙ্গোলিয়ান (সিরিলিক)',
    mnMong: 'মঙ্গোলিয়ান (परंपरागত)',
    mr: 'মারাঠি',
    ms: 'মালয়',
    mt: 'মাল্টিজ',
    mww: 'হমোং ডေါ',
    my: 'মায়ানমার (বর্মী)',
    nb: 'নরওয়েজিয়ান',
    ne: 'नेपाली',
    nl: 'ডাচ',
    noSearchLang: 'ভাষা সমর্থিত নয়',
    nso: 'সেসোথো সা লেবোয়া',
    nya: 'নিয়াঞ্জা',
    or: 'ਓਡੀਆ',
    otq: 'কেরেতারো ওটোমি',
    pa: 'পাঞ্জাবি',
    pl: 'পোলিশ',
    placeholder: 'অনুসন্ধান',
    prs: 'দারি',
    ps: 'পাশ্তো',
    pt: 'পোর্তুগিজ (ব্রাজিল)',
    ptPT: 'পর্তুগিজ (পর্তুগাল)',
    ro: 'রোমানিয়ান',
    ru: 'রাশিয়ান',
    run: 'রুন্ডি',
    rw: 'কিন্যারুয়ান্ডা',
    sd: 'সিন্ধি',
    si: 'සිංහල',
    sk: 'স্লোভাক',
    sl: 'स्लोवेनियाई',
    sm: 'সামোয়ান',
    sn: 'শোনা',
    so: 'সোমালি',
    sq: 'আলবানিয়ান',
    srCyrl: 'সার্বিয়ান (সিরিলিক)',
    srLatn: 'সার্বিয়ান (ল্যাটিন)',
    st: 'সেসোথো',
    sv: 'সুইডিশ',
    sw: 'সোয়াহিলি',
    ta: 'তামিল',
    te: 'తెలుగు',
    th: 'থাই',
    ti: 'তিগ্রিনিয়া',
    tk: 'তুর্কমেন',
    tlhLatn: 'ক্লিঙ্গন',
    tlhPiqd: 'ক্লিঙ্গন (pIqaD)',
    tn: 'সেত್ಸোয়ানা',
    to: 'টোঙ্গান',
    tr: 'তুর্কি',
    tt: 'তাতার',
    ty: 'তাহিতি',
    ug: 'ইউইগুর',
    uk: 'Українська',
    ur: 'উর্দু',
    uz: 'উজবেক (ল্যাটিন)',
    vi: 'ভিয়েতনামি',
    xh: 'খোসা',
    yo: 'ইওরুবা',
    yua: 'ইউকাটেক মায়া',
    yue: 'ক্যান্টোনিজ (ট্র্যাডিশনাল)',
    zh: 'চাইনিজ',
    zhHans: 'সাইনি সিমপ্লিফাইড',
    zhHant: 'চীনা ঐতিহাসিক',
    zu: 'জুলু',
  },
  login: {
    and: 'এবং',
    btn: 'গুগল দিয়ে লগ ইন করুন',
    btn1: 'এখন লগ ইন করুন',
    desc: 'আরও অভিজ্ঞতা আনলক করতে লগ ইন করুন',
    policy: 'গোপনীয়তা নীতি',
    terms: 'ব্যবহার শর্তাবলী',
    tips: 'সাইন আপ করার মাধ্যমে, আমি সম্মতি দিচ্ছি',
    title: 'নোয়াম-এ আপনাকে স্বাগতম',
  },
  pageFooter: {
    follow: { facebook: 'ফেসবুক', title: 'ফলো করুন', twitter: 'টুইটার' },
    legal: { policy: 'গোপনীয়তা নীতি', terms: 'সেবার শর্তাবলী', title: 'আইনি' },
    product: {
      image: 'ইমেজ ট্রান্সলেশন',
      pdf: 'পিডিএফ অনুবাদ',
      title: 'পণ্যসমূহ',
      video: 'ভিডিও অনুবাদ ও সারাংশ',
      web: 'ওয়েব অনুবাদ ও সারাংশ',
    },
    resources: { title: 'সম্পদ' },
    tools: { title: 'সামগ্রী', pdf: 'পিডিএফ অনুবাদ' },
  },
  pageHeader: {
    contact: 'যোগাযোগ',
    help: 'সাহায্য',
    logout: 'লগ আউট',
    logoutSucc: 'লগ আউট করা হয়েছে।',
    pricing: 'মূল্য নির্ধারণ',
    settings: 'সেটিংস',
    signUp: 'লগ ইন',
  },
  pdf: {
    autoDetect: 'স্বয়ংক্রিয় সনাক্ত',
    cancelBtn: 'বাতিল করুন',
    cancelUpload: 'বাতিল করুন',
    chatPdf: {
      summaryError: 'সারাংশ তৈরি ব্যর্থ হয়েছে, অনুগ্রহ করে পরে আবার চেষ্টা করুন',
      chatError: 'চ্যাট ব্যর্থ হয়েছে, অনুগ্রহ করে পরে আবার চেষ্টা করুন',
      Search: 'অনুসন্ধান',
      cancel: 'বাতিল করুন',
      chatTitle: 'নোয়াম-এ আপনাকে স্বাগতম! আপনার পিডিএফ-এর সারসংক্ষেপ এখানে রয়েছে:',
      clear: 'স্পষ্ট',
      clearContent:
        'এটি একটি নতুন কথোপকথন শুরু করবে। বর্তমান কথোপকথন সংরক্ষিত হবে না। আপনি কি নিশ্চিত? ',
      clearDialogTitle: 'দয়া করে নিশ্চিত করুন',
      clearSucc: 'পরিষ্কার করা হয়েছে',
      copy: 'কপি',
      copySucc: 'কপি করা হয়েছে',
      delete: 'মুছুন',
      deleteCancel: 'বাতিল করুন',
      deleteContent: 'ডিলিট করা হলে এই পিডিএফ আর পুনরুদ্ধার করা যাবে না। আপনি কি নিশ্চিত?',
      deleteOk: 'মুছুন',
      deleteSuccess: 'মুছে ফেলা হয়েছে',
      deleteTitle: 'মুছে ফেলা নিশ্চিত করুন',
      expand: 'পতন',
      historyTitle: 'ইতিহাস',
      listError:
        'পড়ার তালিকা লোড করতে ব্যর্থ হয়েছে। অনুগ্রহ করে পরে আবার চেষ্টা করুন, অথবা সাপোর্টে যোগাযোগ করুন।',
      loading: 'লোড হচ্ছে...',
      noDataDesc: 'এখনও কোনো ইতিহাস নেই।',
      noMore: 'আর কোনো কন্টেন্ট নেই।',
      placeholder: 'এই পিডিএফ সম্পর্কে যেকোনো প্রশ্ন করুন',
      summaryTitle: 'আপনি এই প্রশ্নগুলোতে আগ্রহী হতে পারেন:',
    },
    collectionEmpty: 'আপনার সংগ্রহ ফাঁকা است.',
    collectionTab: 'নোট',
    dataLoading: 'লোড হচ্ছে...',
    dialogContent: 'আপনি কি নিশ্চিত আপনি এটি মুছে ফেলতে চান?',
    dialogTitle: 'দয়া করে নিশ্চিত করুন',
    download: {
      both: 'দ্বিভাষিক',
      btn: 'সংরক্ষণ করুন',
      cancel: 'এই উইন্ডো বন্ধ করলে পিডিএফ ডাউনলোড বাতিল হবে। আপনি কি বাতিল করতে চান? সত্যিই?',
      desc: 'ডিভাইসে সংরক্ষণ করুন: অনুবাদগুলো ছবি হিসেবে ডাউনলোড করে; সংরক্ষণ ও প্রিন্ট করুন: অনুবাদগুলো মূল ফরম্যাটে ডাউনলোড করে, কপি সমর্থন সহ।',
      download: 'ডাউনলোড',
      downloadMsg1: 'পিডিএফ অনুবাদ অগ্রগতি:',
      downloadMsg2: 'অনুমানিত অবশিষ্ট সময়:',
      downloadSucc: 'পিডিএফ প্রস্তুত! সংরক্ষণ করতে ক্লিক করুন।',
      downloadTip: 'পিডিএফ ডাউনলোড হচ্ছে। ডাউনলোড ত্রুটি এড়াতে এই উইন্ডো বন্ধ করবেন না।',
      error: 'সংরক্ষণ করতে ব্যর্থ। পরিবর্তে প্রিন্ট করার চেষ্টা করুন।',
      fileName: 'ফাইল নাম:',
      fileType: 'ফাইলের প্রকার:',
      loading: 'সংরক্ষণ করা হচ্ছে...',
      loading2: 'লোড হচ্ছে...',
      minute: 'মিনিট...',
      msg1: 'এই ডকুমেন্টের কিছু অনুবাদ মূল পাঠ্যের চেয়ে দীর্ঘ, এবং ডাউনলোড করা ফাইলে ওভারল্যাপ হতে পারে। আমরা ওয়েবপেজে পড়ার সুপারিশ করি।',
      msg2: 'অনুবাদ এখনও সম্পূর্ণ হয়নি। অনুবাদ শেষ হওয়ার পরে অনুগ্রহ করে ডাউনলোড করুন।',
      msg3: '২. কিছু অনুবাদ খুব দীর্ঘ। টেক্সট ওভারল্যাপ এড়াতে ওয়েবপেজে পড়ুন।',
      msg4: 'অনুবাদ কাজ চলছে। সম্পূর্ণ হওয়ার পরে আবার চেষ্টা করুন।',
      progress:
        'PDF অনুবাদ করা হচ্ছে। অগ্রগতি: {{progress}}, অনুমানকৃত বাকি সময়: {{minutes}} মিনিট...',
      save: 'ডিভাইসে সংরক্ষণ করুন',
      savePrint: 'সংরক্ষণ করুন & প্রিন্ট করুন',
      success: 'ডাউনলোড করা হয়েছে',
      trans: 'শুধুমাত্র অনুবাদ',
      transContinue: 'অনুবাদ চালিয়ে যান',
    },
    downloadBtn: 'ডাউনলোড',
    dragTipModal: {
      black: 'স্থান',
      leftKey: 'বাম বোতাম',
      ok: 'বুঝেছি',
      press: 'প্রেস',
      tips: 'ট্র্যাগ করে দেখুন',
    },
    entry: 'পিডিএফ ফাইলসমূহ',
    fileErrMsg:
      'ফাইল পড়া ব্যর্থ হয়েছে। অনুগ্রহ করে পরে আবার চেষ্টা করুন, অথবা সাপোর্টে যোগাযোগ করুন।',
    fileMsg: 'বর্তমান ফাইল আকার:',
    fileMsg2: 'অনুগ্রহ করে 300MB-এর চেয়ে ছোট একটি ফাইল আপলোড করুন।',
    freeBannerBtn: 'আপগ্রেড',
    freeBannerTips: 'ফ্রি পিডিএফ অনুবাদের সীমা পৌঁছেছে',
    guide: {
      placeholder: 'এখানে পিডিএফ লিঙ্ক পেস্ট করুন',
      start: 'অনুবাদ শুরু করুন',
      text1: 'দ্বিভাষিক পাঠ',
      text2:
        'দক্ষতা বাড়ানোর জন্য মূল পাঠ্য এবং অনুবাদকে পাশাপাশি তুলনা করার জন্য দ্বিভাষিকভাবে পড়ুন।',
      text3: 'আপনার পিডিএফ-এর সাথে চ্যাট করুন',
      text4:
        'এআই-চালিত বিশ্লেষণ ও সারাংশন. আপনার পিডিএফ সম্পর্কে প্রশ্ন করুন, এবং তাৎক্ষণিক উত্তর পান করুন।',
      text5: 'সঠিক ও দক্ষ',
      text6: 'বৃহত্তর নির্ভুলতা এবং দক্ষতার জন্য AI-সমর্থিত পিডিএফ অনুবাদ।',
      title1: 'দ্বিভাষিক অনুবাদ',
      title2: 'আপনার PDF-এর সাথে চ্যাট করুন',
      toast: '.pdf শেষ হওয়া একটি বৈধ অনলাইন পিডিএফ লিঙ্ক প্রবেশ করুন',
    },
    hasTransTask: 'একটি অনুবাদ কাজ চলছে। অনুগ্রহ করে অপেক্ষা করুন।',
    hoverTrans: 'প্যারাগ্রাফের জন্য হোভার-টু-ট্রান্সলেট',
    initial: 'পিডিএফ অনুবাদ করুন',
    installText: 'দৈনন্দিন অনুবাদের জন্য আপনার একক স্টপ সমাধান।',
    installText2: 'প্রথমে এক্সটেনশন ইনস্টল করুন',
    installTips:
      'আরও বেশি পিডিএফ অনুবাদ এবং আরও মসৃণ ওয়েবসাইট অনুবাদের জন্য এক্সটেনশন ইনস্টল করুন:',
    kw: 'মৌখিক',
    link: 'লিঙ্ক',
    listError:
      'PDF লোড করতে ব্যর্থ। অনুগ্রহ করে পরে আবার চেষ্টা করুন, বা সাপোর্টের সাথে যোগাযোগ করুন।',
    memoTotalCount: 'মোট 1 আইটেম',
    new: 'নতুন ফাইল',
    noId: 'ফাইল আইডি পাওয়া যায়নি।',
    notPdf: 'শুধুমাত্র পিডিএফ ফাইল।',
    okBtn: 'মুছুন',
    okBtn2: 'সমਯা হয়েছে',
    original:
      'আপনি একটি অত্যন্ত সঠিক এবং নির্ভরযোগ্য AI যা একটি নির্দিষ্ট JSON স্কিমারকে সঠিকভাবে অনুসরণ করে JSON আউটপুট তৈরি করতে ডিজাইন করা হয়েছেন।\n\nআপনাকে এই নিয়মগুলো মানতে হবে:\n1. JSON স্কিমার কাঠামোতে কঠোরভাবে পালন করুন।\n2. সমস্ত ডেটা টাইপ, প্রয়োজনীয় ফিল্ড এবং সীমাবদ্ধতাগুলো ঠিকভাবে মেলান।\n3. কোনো অতিরিক্ত টেক্সট, ব্যাখ্যা, মার্কডাউন বা কমেন্ট অন্তর্ভুক্ত করবেন না।\n4. শুধুমাত্র JSON অবজেক্ট আউটপুট করুন — কোনো কোড ব্লক, প্রিলিমিনারি বা মোড়ানো নয়।\n\nনীচে স্কিমার তথ্য দেওয়া হয়েছে:\n- স্কিমার নাম: translate_result\n- JSON স্কিমা:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'সমান্তরাল',
    parseErrDialogContent:
      'এই পিডিএফ লিঙ্কটি সরাসরি অনুবাদ করা যাবে না। অনুগ্রহ করে পিডিএফ ডাউনলোড করুন এবং অনুবাদের জন্য আপলোড করুন।',
    parseErrTips: 'ফাইল পার্স করতে ব্যর্থ হয়েছে',
    parseFileToast:
      'ফাইল পার্স করা ব্যর্থ। অনুগ্রহ করে পরে আবার চেষ্টা করুন, বা সাপোর্টের সাথে যোগাযোগ করুন।',
    pdfLoading: 'পার্সিং করা হচ্ছে...',
    searchPlaceholder: 'অনুসন্ধান',
    selectTrans: 'অনুবাদের জন্য টেক্সট নির্বাচন করুন',
    shareBtn: 'শেয়ার',
    shareBtnText1: 'শেয়ার লিঙ্ক তৈরি করুন',
    shareBtnText2: 'শেয়ারকৃত কন্টেন্ট আপডেট করুন',
    shareModal: {
      cancel: 'বাতিল করুন',
      copy: 'কপি',
      copySucc: 'লিঙ্ক কপি করা হয়েছে',
      custom: 'কাস্টমাইজ করুন:',
      errMsg:
        'নির্বাচিত সামগ্রীটি এখনও সম্পূর্ণরূপে অনুবাদ করা হয়নি। শেয়ার করার আগে অনুবাদ করুন।',
      gen: 'শেয়ার',
      modify: 'সম্পাদনা',
      notSupport: 'এই ভাষাটি বর্তমানে সমর্থিত নয়।',
      page: 'পৃষ্ঠাগুলো',
      pageNuErr: 'দয়া করে একটি বৈধ পৃষ্ঠা নম্বর লিখুন।',
      range: 'দৃষ্টিপ্রস্থ:',
      remain: 'অবশিষ্ট',
      remain1: 'মোট অনুমানক সময়:',
      search: 'অনুসন্ধান',
      settings: 'শেয়ার সেটিংস:',
      shareSetting: 'শেয়ার সেটিংস',
      shareText: 'শেয়ার',
      shareTips: 'অনুবাদকৃত পিডিএফ লিঙ্কটি আপনার বন্ধুদের সাথে শেয়ার করুন:',
      sourceLang: 'প্রারম্ভিক: ',
      target: 'প্রাপক:',
      text1: 'শেয়ার সেটিংস',
      text2: 'শেয়ার লিঙ্ক তৈরি করুন',
      totalPage: 'মোট 1 পৃষ্ঠা',
      trans: 'অনুবাদ করুন',
      translateTips:
        'টিপস: যদি অনুবাদে সময় লাগে তবে আপনি এই উইন্ডো বন্ধ করে পরে শেয়ার করতে পারেন।',
      translating: 'পিডিএফ অনুবাদ করা হচ্ছে...',
      update: 'শেয়ার লিঙ্ক আপডেট করুন',
    },
    shareMsg1: 'শেয়ার লিঙ্ক তৈরি হয়েছে।',
    shareMsg2: 'শেয়ারকৃত কন্টেন্ট আপডেট করা হয়েছে।',
    shareMsg3:
      'শেয়ার লিঙ্ক তৈরি করতে ব্যর্থ হয়েছে। অনুগ্রহ করে পরে আবার চেষ্টা করুন, বা সাপোর্টের সাথে যোগাযোগ করুন।',
    shareMsg4:
      'শেয়ারকৃত কন্টেন্ট আপডেট করতে ব্যর্থ হয়েছে। অনুগ্রহ করে পরে আবার চেষ্টা করুন, অথবা সাপোর্টের সাথে যোগাযোগ করুন।',
    shareTips: 'আপনার পিডিএফ অনুবাদ প্রস্তুত হয়েছে! এটি আপনার বন্ধুদের সাথে শেয়ার করুন।',
    start: 'আপনার ফ্রি ট্রায়াল শুরু করুন',
    thumbnail: 'সূচিপত্র',
    toast1: 'PDF লোড হচ্ছে। অনুগ্রহ করে পরে আবার চেষ্টা করুন।',
    toast2: 'পিডিএফ সামগ্রী প্রক্রিয়া করা হচ্ছে। ডায়ালগ বর্তমানে সমর্থিত নয়।',
    toast3: 'ডাউনলোড করা হচ্ছে। ডাউনলোড শেষ হওয়ার পরে আবার চেষ্টা করুন।',
    toolbar: { Adjust: 'সামঞ্জস্য করা', autoFit: 'অটো-ফিট' },
    trans: 'অনুবাদ',
    transSucc: 'অনুবাদ সফল হয়েছে!',
    unLoginToast: 'এই ফিচার ব্যবহার করতে অনুগ্রহ করে লগ ইন করুন।',
    uploadBtn: 'আপলোড',
    uploadErr: 'ফাইল আপলোড ব্যর্থ হয়েছে। দয়া করে পরে আবার চেষ্টা করুন বা সাপোর্টে যোগাযোগ করুন।',
    uploadErrSignUrl:
      'আপলোড URL পাওয়া যায়নি। অনুগ্রহ করে পরে আবার চেষ্টা করুন, বা সাপোর্টের সাথে যোগাযোগ করুন।',
    uploadMsg1: 'এখানে আপনার ফাইল টেনে রাখুন।',
    uploadMsg2: 'সমর্থিত ফাইল টাইপ: PDF  |  সর্বোচ্চ ফাইল সাইজ: 300MB',
    uploadMsg3: 'এখানে ফাইল নির্বাচন করতে ক্লিক করুন বা ড্র্যাগ অ্যান্ড ড্রপ করুন।',
    uploading: 'আপলোড হচ্ছে',
    uploadingMsg: 'আপলোড হচ্ছে। দয়া করে অপেক্ষা করুন।',
    uploadingMsg1: 'ফাইল আপলোড হচ্ছে। পরে আবার চেষ্টা করুন।',
    uploadingMsg2: 'একটি ফাইল বর্তমানে রূপান্তর করা হচ্ছে। অনুগ্রহ করে পরে আবার চেষ্টা করুন।',
    uploadingMsg3:
      'কনভার্সন প্রগ্রেস অনুরোধ ব্যর্থ হয়েছে। অনুগ্রহ করে পরে আবার চেষ্টা করুন, অথবা সাপোর্টের সাথে যোগাযোগ করুন।',
    uploadingMsg4:
      'নোয়াম লোকাল ফাইলগুলো অ্যাক্সেস করতে পারছে না। অনুগ্রহ করে অনুবাদের জন্য ম্যানুয়ালি একটি পিডিএফ আপলোড করুন।',
    uploadingMsg5:
      'ফাইল URL প্রাপ্ত করতে ব্যর্থ হয়েছে। অনুগ্রহ করে পরে আবার চেষ্টা করুন, অথবা সাপোর্টের সাথে যোগাযোগ করুন।',
    video: 'ভিডিও',
    vipBannerBtn: 'আপগ্রেড',
    vipBannerTips: 'এই মাসের জন্য আপনার পিডিএফ অনুবাদ সীমা পৌঁছেছেন।',
    webTrans: 'পূর্ণ ক্রস-রেফারেন্স',
  },
  pricing: {
    FAQ: 'সচরাচর জিজ্ঞাসিত প্রশ্ন',
    FQAObj: {
      a1: 'হ্যাঁ, নোয়াম একটি ফ্রি প্ল্যান অফার করে যা আপনি অবিলম্বে ব্যবহার করতে পারেন।',
      a2: 'আমরা তিনটি মেম্বারশিপ প্ল্যান অফার করি: প্রো, প্রো+, এবং এন্টারপ্রাইজ। আপনি মাসিক বা বার্ষিকভাবে প্রদান করতে বেছে নিতে পারেন। বার্ষিক বিলিং উল্লেখযোগ্য সাশ্রয় প্রদান করে।',
      a3: 'উভয় প্ল্যানে সমস্ত বৈশিষ্ট্য উপলব্ধ। মূল পার্থক্য হল খরচ: বার্ষিক সাবস্ক্রিপশন মোটরूपে কম খরচ করে। মাসিক সাবস্ক্রিপশন প্রতি মাসে বিল দেওয়া হয়, যখন বার্ষিক প্ল্যান প্রতি বছর একবার বিল দেওয়া হয়।',
      a4: 'আপনি আপনার অ্যাকাউন্ট সেটিংস থেকে যেকোনো সময় আপনার সাবস্ক্রিপশন বাতিল করতে পারেন।',
      q1: 'কোনো ফ্রি প্ল্যান আছে কি?',
      q2: 'কি মূল্য নির্ধারণ পরিকল্পনা এবং পেমেন্ট বিকল্পগুলো পাওয়া যায়?',
      q3: 'মাসিক সাবস্ক্রাইব করা এবং বার্ষিক সাবস্ক্রাইব করার মধ্যে কি পার্থক্য আছে?',
      q4: 'আমি কিভাবে আমার সাবস্ক্রিপশন বাতিল করতে পারি?',
    },
    around: 'চারপাশে',
    billedMonthly: 'মাসিকভাবে বিল করা হয়',
    billedYearly: 'বার্ষিক বিল',
    day: 'দিন',
    desc: 'প্ল্যানগুলো তুলনা করুন এবং সেরাটি বেছে নিন',
    detailedCompare: 'প্ল্যানগুলি তুলনা করুন',
    discount: '২০% ছাড়',
    enterprise: {
      benefit1: 'প্রাইরিটি গ্রাহক সহায়তা',
      benefit2: 'একাধিক ব্যবহারকারী',
      benefit3: 'স্বয়ংসস্তু সমাধান',
      benefit5: 'নিযুক্ত অ্যাকাউন্ট ম্যানেজার',
      btn: 'আমাদের সাথে যোগাযোগ করুন',
      recommendText: 'কাস্টম প্ল্যান (≥3 জন)',
      talkToUs: 'যোগাযোগ করুন',
    },
    free: {
      benefit1: 'দৈনিক 100 বার তাৎক্ষণিক অনুবাদ',
      benefit2: 'ওয়েবসাইট অনুবাদ ও সারাংশ',
      benefit3: '30 টি ইমেজ ট্রান্সলেশন',
      benefit4: 'ভিডিও অনুবাদ ও সারসংক্ষেপ',
      benefit5: '10টি পিডিএফ অনুবাদ',
      benefit6: '5,000 টোকেন',
      btn: 'ফ্রি ট্রাই করুন',
      recommendText: 'ফ্রি ট্রায়াল',
    },
    imageTranslation: 'ইমেজ ট্রান্সলেশন',
    month: 'মাস',
    monthly: 'মাসিক',
    pageTitle: 'মূল্য নির্ধারণ',
    pdf: {
      chat: 'পিডিএফ চ্যাট কোয়েরি',
      maxPage: 'প্রতি PDF-এর সর্বোচ্চ পৃষ্ঠা',
      translation: 'পিডিএফ অনুবাদ',
    },
    preMonth: 'প্রতি মাসে',
    pro: {
      benefit1: 'প্রাইরিটি গ্রাহক সহায়তা',
      benefit2: '10 লাখ টোকেন/মাস',
      benefit3: 'ওয়েবসাইট অনুবাদ ও সারাংশ',
      benefit4: '200 টি ইমেজ ট্রান্সলেশন',
      benefit5: 'ভিডিও অনুবাদ ও সারাংশ',
      benefit6: '200 টি পিডিএফ অনুবাদ',
      btn: 'শুরু করুন',
      recommendText: 'সবচেয়ে জনপ্রিয়',
    },
    proPlus: {
      benefit1: 'প্রাইরিটি গ্রাহক সহায়তা',
      benefit2: '3,000,000 টোকেন/মাস',
      benefit3: 'ওয়েবসাইট অনুবাদ ও সারাংশ',
      benefit4: '500 টি ইমেজ অনুবাদ',
      benefit5: 'ভিডিও অনুবাদ ও সারসংক্ষেপ',
      benefit6: '500 টি পিডিএফ অনুবাদ',
      recommendText: 'সেরা মান',
    },
    video: { summary: 'ভিডিও সারাংশ', translation: 'ভিডিও অনুবাদ' },
    web: {
      contrastiveTranslation: 'দ্বিভাষিক অনুবাদ',
      dictionaryTranslation: 'নির্বাচন অনুবাদ',
      hoverTranslation: 'হোভার ট্রান্সলেশন',
      instantTranslation: 'তাত্ক্ষণিক অনুবাদ',
      summary: 'ওয়েব পৃষ্ঠার সারাংশ',
    },
    yearly: 'বার্ষিক',
  },
  privacy: {
    block1:
      'নোয়াম ("নোয়াম," "আমরা," "আমাদের," বা "আমাদেরকে") আপনার গোপনীয়তাকে সম্মান করে এবং আপনার কাছ থেকে বা আপনার সম্পর্কে আমরা প্রাপ্ত যেকোনো তথ্য রক্ষা করার প্রতিশ্রুতিবদ্ধ। এই গোপনীয়তা নীতিটি আমাদের ওয়েবসাইট, অ্যাপ্লিকেশন এবং সার্ভিস (সম্মিলিতভাবে "সার্ভিস") ব্যবহার করার ফলে ব্যক্তিগত তথ্য সংগ্রহ বা ব্যবহারের সাথে সম্পর্কিত আমাদের প্রাকৃতিক প্রথাগুলো বর্ণনা করে। এই গোপনীয়তা নীতিটি আমাদের ব্যবসায়িক প্রোডাক্ট গ্রাহকদের পক্ষে পরিচালিত বিষয়বস্তুর ক্ষেত্রে প্রযোজ্য নয়, যেমন আমাদের API। এই ডেটার ব্যবহার আমাদের গ্রাহক চুক্তির অধীনে থাকে, যা এই প্রোডাক্টগুলোর অ্যাক্সেস এবং ব্যবহারকে কভার করে।',
    block10:
      'আমরা কমারশিয়ালি যুক্তিসঙ্গত প্রযুক্তিগত, প্রশাসনিক এবং সাংগঠনিক ব্যবস্থা বাস্তবায়ন করি যাতে অনলাইন এবং অফলাইন ব্যক্তিগত তথ্যকে ক্ষতি、 অপব্যবহার、 অনધিকারিতা অ্যাক্সেস、 প্রকাশ、 পরিবর্তন বা শত্রুতামূলক কার্য থেকে রক্ষা করা যায়। তবে, কোনো ইন্টারনেট বা ইমেল ট্রান্সমিশন সম্পূর্ণ নিরাপত্তা বা সঠিকতা গ্যারান্টি দিতে পারে না। বিশেষ করে, আমাদের কাছে পাঠানো বা আমাদের কাছ থেকে পাঠানো ইমেলগুলি নিরাপদ নাও হতে পারে। তাই, সার্ভিস বা ইমেলের মাধ্যমে আমাদের কাছে কোন তথ্য পাঠাতে চান সে নির্ধারণ করার সময় আপনার বিশেষভাবে সতর্ক থাকা উচিত। উপরন্তু, সার্ভিস বা থার্ড পার্টি ওয়েবসাইটের গোপনীয়তা সেটিংস বা নিরাপত্তা ব্যবস্থাগুলির কোনো বাধার জন্য আমরা দায়ী নই। আমরা আপনাকে সার্ভিস প্রদান করার জন্য বা বিরোধ সমাধান、 নিরাপত্তা ও সুরক্ষার কারণে বা আমাদের আইনি বাধ্যবাধকতা মেনে চলার মতো অন্যান্য বৈধ ব্যবসায় উদ্দেশ্যের জন্য প্রয়োজনীয়তা পর্যন্ত আপনার ব্যক্তিগত তথ্য সংরক্ষণ করব। আমরা ব্যক্তিগত তথ্য কতকালীন সংরক্ষণ করব তা অনেক কারণের উপর নির্ভর করবে, যেমন তথ্যের পরিমাণ、 প্রকৃতি、 সংবেদনশীলতা、 অনધিকারিতা ব্যবহার বা প্রকাশের সম্ভাব্য ঝুঁকি、 তথ্য প্রক্রিয়া করার উদ্দেশ্য এবং অন্যান্য আইনি বাধ্যবাধক বিবেচনা।',
    block11:
      'আমরা সময়ের সাথে সাথে এই গোপনীয়তা নীতিটি আপডেট করতে পারি। যখন আমরা তা করব, তখন আমরা এই পৃষ্ঠায় একটি আপডেটेड সংস্করণ পোস্ট করব, যদি না প্রযোজ্য আইন অন্যথায় নির্দেশ করে।',
    block12:
      'এই গোপনীয়তা নীতি সম্পর্কে যদি আপনার কোনো অপ্রত্যাশিত প্রশ্ন বা উদ্বেগ থাকে, তাহলে অনুগ্রহ করে আমাদের গ্রাহক সেবা部门ে যোগাযোগ করুন। ইমেল:',
    block2: 'আমরা আপনার সাথে সম্পর্কিত নিম্নলিখিত ব্যক্তিগত তথ্য ("ব্যক্তিগত তথ্য") সংগ্রহ করি:',
    block3:
      'আপনার দ্বারা প্রদত্ত তথ্য: আপনি যখন আমাদের সেবা ব্যবহার করার বা আমাদের সাথে যোগাযোগ করার জন্য একটি অ্যাকাউন্ট তৈরি করেন, তখন আমরা নিম্নরূপ ব্যক্তিগত তথ্য সংগ্রহ করি:',
    block4:
      'সার্ভিস ব্যবহারের মাধ্যমে স্বয়ংক্রিয়ভাবে গৃহীত ব্যক্তিগত তথ্য: আপনি যখন সার্ভিসগুলো অ্যাক্সেস করেন, ব্যবহার করেন বা ইন্টারঅ্যাক্ট করেন, তখন আমরা আপনার অ্যাক্সেস, ব্যবহার বা ইন্টারঅ্যাকশন সম্পর্কে নিম্নলিখিত তথ্য গ্রহণ করি ("প্রযুক্তিগত তথ্য"):',
    block5: 'আমরা নিম্নলিখিত উদ্দেশ্যগুলির জন্য ব্যক্তিগত তথ্য ব্যবহার করতে পারি:',
    block6:
      'সারাংশ বা পরিচয়-অপসারণ করা তথ্য: পরিচয় সনাক্তকরণের উদ্দেশ্যে পুনর্ব্যবহার রোধ করতে আমরা ব্যক্তিগত তথ্য সংযুক্ত বা পরিচয়-অপসারণ করতে পারি এবং এমন তথ্য ব্যবহার করতে পারি আমাদের সেবার কার্যকারিতা বিশ্লেষণ করতে, আমাদের সেবাগুলো উন্নত ও বৈশিষ্ট্য যুক্ত করতে, গবেষণা চালানো এবং অনুরূপ উদ্দেশ্যে। উপরন্তু, আমরা আমাদের সেবা ব্যবহারকারীদের সাধারণ আচরণ ও বৈশিষ্ট্য বিশ্লেষণ করতে পারি এবং সংযুক্ত তথ্য তৃতীয় পক্ষের সাথে ভাগ করতে পারি, এই সংযুক্ত তথ্য প্রকাশ করতে পারি বা সাধারণভাবে প্রাপ্য করতে পারি। আমরা সেবার মাধ্যমে, কুকি-এর মাধ্যমে এবং এই গোপনীয়তা নীতিতে বর্ণিত অন্যান্য উপায়ের মাধ্যমে সংযুক্ত তথ্য সংগ্রহ করতে পারি। আমরা পরিচয়-অপসারণ করা তথ্যকে বেনামী বা পরিচয়-অপসারণ করা আকারে রাখব এবং ব্যবহার করব, এবং আইনের দ্বারা প্রয়োজন না হলে আমরা এমন তথ্যের পুনরায় পরিচয় সনাক্তকরণ করার চেষ্টা করব না।',
    block7:
      'কিছু নির্দিষ্ট ক্ষেত্রে, আইনের প্রয়োজন না থাকলে, আপনার ব্যক্তিগত তথ্য আমরা তৃতীয় পক্ষের কাছে আপনার আরও নোটিশ ছাড়াই প্রদান করতে পারি:',
    block8:
      'আপনার ভৌগলিক অবস্থানের উপর নির্ভর করে, ইউরোপীয় অর্থনৈতিক অঞ্চল, যুক্তরাজ্য এবং বিশ্বব্যাপী ব্যক্তিদের তাদের ব্যক্তিগত তথ্য সম্পর্কে কিছু বিধিবদ্ধ অধিকার থাকতে পারে। উদাহরণস্বরূপ, আপনার নিম্নলিখিত অধিকার থাকতে পারে:',
    block9:
      'এই সার্ভিসে নোয়াম দ্বারা পরিচালিত বা নিয়ন্ত্রিত নয় এমন অন্য ওয়েবসাইটের লিঙ্ক থাকতে পারে, যার মধ্যে সোশ্যাল মিডিয়া সার্ভিসও রয়েছে ("তৃতীয় পক্ষের ওয়েবসাইট"). তৃতীয় পক্ষের ওয়েবসাইটগুলোতে আপনি যে তথ্য শেয়ার করেন তা এই গোপনীয়তা নীতি দ্বারা নয়, বরং তৃতীয় পক্ষের ওয়েবসাইটগুলোর নির্দিষ্ট গোপনীয়তা নীতি এবং সেবা শর্তাবলী দ্বারা নিয়ন্ত্রিত হবে। আমরা এই লিঙ্কগুলো সুবিধার জন্য প্রদান করি এবং এর মাধ্যমে এই ওয়েবসাইটগুলোর প্রতি আমাদের সমর্থন বা পর্যালোচনা বোঝানো হয় না। তাদের গোপনীয়তা নীতি এবং শর্তাবলী সম্পর্কে তথ্যের জন্য দয়া করে সরাসরি তৃতীয় পক্ষের ওয়েবসাইটগুলোতে যোগাযোগ করুন।',
    subBlock1:
      'অ্যাকাউন্ট তথ্য: যখন আপনি আমাদের প্ল্যাটফর্মে একটি অ্যাকাউন্ট তৈরি করেন, আমরা আপনার অ্যাকাউন্ট সম্পর্কিত তথ্য সংগ্রহ করি, যার মধ্যে আপনার নাম, যোগাযোগের তথ্য, অ্যাকাউন্ট ক্রেডেনশিয়াল, পেমেন্ট কার্ড তথ্য এবং লেনদেনের ইতিহাস অন্তর্ভুক্ত থাকে ("অ্যাকাউন্ট তথ্য")।',
    subBlock10: 'সেবা প্রদান, পরিচালনা, রক্ষণাবেক্ষণ এবং/অথবা বিশ্লেষণ করা;',
    subBlock11: 'আপনার সাথে যোগাযোগ করা;',
    subBlock12: 'নতুন পণ্য ও পরিষেবা তৈরি করা;',
    subBlock13:
      'ফ্রாட, অপরাধমূলক কার্যকলাপ বা আমাদের পরিষেবाओं का दुरुपयोग রোধ করা এবং আমাদের আইটি সিস্টেম, আর্কিটেকচার এবং নেটওয়ার্কের নিরাপত্তা রক্ষা করা;',
    subBlock14: 'ব্যবসায় স্থানান্তর পরিচালনা করা;',
    subBlock15:
      'আইনি বাধ্যবাধকতা ও আইনি প্রক্রিয়া মেনে চলা, আমাদের অধিকার, গোপনীয়তা, নিরাপত্তা বা সম্পত্তি সুরক্ষা করা, সেইসাথে আমাদের সংযুক্ত প্রতিষ্ঠান, আপনি বা অন্যান্য তৃতীয় পক্ষের অধিকার, গোপনীয়তা, নিরাপত্তা বা সম্পত্তি সুরক্ষা করা।',
    subBlock16:
      'সাপ্লায়াররা এবং সার্ভিস প্রদানকারীরা: ব্যবসায়িক অপারেশনাল প্রয়োজনীয়তা মেটানো এবং নির্দিষ্ট সেবা ও ফাংশন সম্পাদন করতে আমাদের সহায়তা করার জন্য, আমরা সাপ্লায়াররা এবং সার্ভিস প্রদানকারীদের কাছে ব্যক্তিগত তথ্য প্রদান করতে পারি, যার মধ্যে রয়েছে হোস্টিং সার্ভিস প্রদানকারী, ক্লাউড সার্ভিস প্রদানকারী, এবং অন্যান্য তথ্য প্রযুক্তি সার্ভিস প্রদানকারী, ইমেল যোগাযোগ সফ্টওয়্যার, এবং ওয়েব অ্যানালিটিক্স সার্ভিস প্রদানকারী ইত্যাদি। এই অংশীদাররা আমাদের জন্য তাদের দায়িত্ব পালন করার সময় শুধুমাত্র আমাদের নির্দেশনায় ব্যক্তিগত তথ্য অ্যাক্সেস, প্রক্রিয়া বা স্টোর করবে।',
    subBlock17:
      'ব্যবসায় স্থানান্তর: যদি আমরা কৌশলগত লেনদেন, পুনর্গঠন, দেউলিয়াত, দেউলিয়াত দ্বারা অধিগ্রহণ, বা পরিষেবাগুলি অন্য প্রদানকারীর কাছে স্থানান্তর করি (সম্মিলিতভাবে "লেনদেন"), তাহলে আপনার ব্যক্তিগত তথ্য এবং অন্যান্য তথ্য যথাযথতা যাচাইের সময় লেনদেনের প্রতিপক্ষ এবং লেনদেনে সহায়তা করার অন্যান্য পক্ষের সাথে ভাগ করা হতে পারে এবং অন্যান্য সম্পদের সাথে লেনদেনের অংশ হিসেবে উত্তরসূরি বা সংযুক্ত কোম্পানিতে স্থানান্তর করা হতে পারে।',
    subBlock18:
      'আইনি প্রয়োজনীয়তা: আমরা আপনার ব্যক্তিগত তথ্য সরকারী কর্তৃপক্ষ, শিল্প সহকর্মী বা অন্যান্য তৃতীয় পক্ষের সাথে শেয়ার করতে পারি, যার মধ্যে আমাদের সার্ভিসের সাথে আপনার মিথস্ক্রিয়া তথ্য অন্তর্ভুক্ত, (1) যদি আইন দ্বারা প্রয়োজন হয় বা যদি আমরা বিশ্বাস করি যে আইনি বাধ্যবাধকতা মেনে চলার জন্য এই ধরনের পদক্ষেপ প্রয়োজনীয়; (2) আমাদের অধিকার বা সম্পত্তি রক্ষা ও রক্ষা করার জন্য; (3) যদি আমরা একত্রিভাবে সিদ্ধান্ত নেই যে আমাদের শর্তাবলী, নীতি বা আইন লঙ্ঘন হয়েছে; (4) জালিয়াতি বা অন্যান্য অবৈধ কার্যকলাপ সনাক্ত বা প্রতিরোধ করার জন্য; (5) আমাদের পণ্য, কর্মচারী বা ব্যবহারকারী, বা জনসাধারণের নিরাপত্তা, নিরাপত্তা, সকলাংশ রক্ষা করার জন্য; বা (vi) আইনি দায়বদ্ধতা থেকে রক্ষা করার জন্য।',
    subBlock19:
      'আপনার ব্যক্তিগত তথ্য এবং তা কীভাবে প্রক্রিয়া করা হয় সে সম্পর্কে তথ্য অ্যাক্সেস করুন।',
    subBlock2:
      'আপনি যখন আমাদের সার্ভিস ব্যবহার করেন, তখন আমরা আপনার ইনপুট, ফাইল আপলোড বা আমাদেরকে প্রদানকৃত ফিডব্যাক ("কন্টেন্ট") থেকে ব্যক্তিগত তথ্য সংগ্রহ করি।',
    subBlock20: 'আমাদের রেকর্ড থেকে আপনার ব্যক্তিগত তথ্য মুছে ফেলার অনুরোধ।',
    subBlock21: 'আপনার ব্যক্তিগত তথ্য সংশোধন করুন বা আপডেট করুন।',
    subBlock22: 'তৃতীয় পক্ষের কাছে আপনার ব্যক্তিগত তথ্য স্থানান্তর করুন (ডেটা পোর্টেবিলিটি)।',
    subBlock23: 'আপনার ব্যক্তিগত তথ্য প্রক্রিয়াকরণের উপায় সীমিত করুন।',
    subBlock24:
      'আপনার সম্মতি প্রত্যাহার করুন—যেখানে আমরা প্রক্রিয়াকরণের আইনি ভিত্তি হিসেবে সম্মতির উপর নির্ভর করছি, আপনি যে কোনো সময়ে আপনার সম্মতি প্রত্যাহার করতে পারেন।',
    subBlock25: 'আপনার ব্যক্তিগত তথ্যের প্রক্রিয়াকরণ পদ্ধতির বিরুদ্ধে আপত্তি জানান।',
    subBlock26: 'আমাদের সেবা উন্নত করা এবং গবেষণা পরিচালনা করা;',
    subBlock3:
      'যোগাযোগ তথ্য: আপনি যদি আমাদের কাছে বার্তা পাঠান, তাহলে আমরা আপনার নাম, যোগাযোগের তথ্য এবং আপনার বার্তাগুলির বিষয়বস্তু সংগ্রহ করব ("যোগাযোগ তথ্য")।',
    subBlock4:
      'সোশ্যাল মিডিয়া তথ্য: আমাদের ইনস্টাগ্রাম, ফেসবুক, মিডিয়াম, টুইটার, ইউটিউব এবং লিঙ্কডইনের মতো সোশ্যাল মিডিয়া ওয়েবসাইটে পৃষ্ঠা রয়েছে। আপনি যখন আমাদের সোশ্যাল মিডিয়া পৃষ্ঠাগুলোর সাথে ইন্টারঅ্যাক্ট করেন, তখন আমরা আপনার যে ব্যক্তিগত তথ্য প্রদান করতে চান তা সংগ্রহ করি, যেমন আপনার যোগাযোগ বিবরণ ("সোশ্যাল ইনফরমেশন")। উপরন্তু, আমাদের সোশ্যাল মিডিয়া পৃষ্ঠাগুলো হোস্ট করা কোম্পানিগুলো আমাদের সোশ্যাল মিডিয়া কার্যকলাপ সম্পর্কে সংযুক্ত তথ্য এবং বিশ্লেষণ প्रदান করতে পারে।',
    subBlock5:
      'লগ ডেটা: আমাদের সার্ভিস ব্যবহার করার সময় আপনার ব্রাউজার দ্বারা স্বয়ংক্রিয়ভাবে প্রেরিত তথ্য। লগ ডেটার মধ্যে আপনার ইন্টারনেট প্রোটোকল (আইপি) ঠিকানা, ব্রাউজারের ধরন ও সেটিংস, আপনার অনুরোধের তারিখ ও সময় এবং আপনি কীভাবে আমাদের ওয়েবসাইটের সাথে ইন্টার্যাক্ট করেন তা অন্তর্ভুক্ত থাকে।',
    subBlock6:
      'ব্যবহারের ডেটা: আমরা সেবাটির ব্যবহার সম্পর্কে স্বয়ংক্রিয়ভাবে তথ্য সংগ্রহ করতে পারি, যেমন আপনি যে ধরনের কন্টেন্ট দেখেন বা ইন্টার্যাক্ট করেন, আপনি যে ফিচারগুলো ব্যবহার করেন, আপনি যে ক্রিয়াকলাপগুলো করেন, সেইসাথে আপনার টাইম জোন, দেশ, অ্যাক্সেসের তারিখ ও সময়, ইউজার এজেন্ট ও সংস্করণ, কম্পিউটার বা মোবাইল ডিভাইসের ধরন, এবং আপনার কম্পিউটার সংযোগ।',
    subBlock7:
      'ডিভাইস তথ্য: এতে ডিভাইসের নাম, অপারেটিং সিস্টেম, ডিভাইস আইডেন্টিফায়ার এবং আপনি যে ব্রাউজার ব্যবহার করছেন তা অন্তর্ভুক্ত থাকে। সংগ্রহ করা তথ্য আপনার ব্যবহৃত ডিভাইসের ধরন এবং এর সেটিংসের উপর নির্ভর করতে পারে।',
    subBlock8:
      'কুকি: আমরা আমাদের সার্ভিসগুলি চালানো ও পরিচালনা করতে এবং আপনার অভিজ্ঞতা উন্নত করতে কুকি ব্যবহার করি। একটি "কুকি" হল আপনি যে ওয়েবসাইটটি ভিজিট করেন তার দ্বারা আপনার ব্রাউজারে পাঠানো তথ্য। আপনি আপনার ব্রাউজারকে সকল কুকি গ্রহণ করার জন্য, সকল কুকি প্রত্যাখ্যান করার জন্য, অথবা যখন একটি কুকি প্রদান করা হয় তখন আপনাকে বার্তা দেওয়ার জন্য সেট করতে পারেন যাতে আপনি প্রতি বার গ্রহণ করা কিনা সিদ্ধান্ত নিতে পারেন। যাইহোক, কুকি প্রত্যাখ্যান করলে আপনাকে ওয়েবসাইটের নির্দিষ্ট অংশ বা বৈশিষ্ট্যগুলো ব্যবহার করতে বাধা দেওয়া হতে পারে বা এর প্রদর্শন বা কার্যকারিতাকে নেতিবাচকভাবে প্রভাবিত করতে পারে। কুকি সম্পর্কে আরও তথ্যের জন্য, দয়া করে অল অ্যাউট কুকি ভিজিট করুন।',
    subBlock9:
      'এনালিটিক্স: আমরা বিভিন্ন অনলাইন অ্যানালিটিক্স প্রোডাক্ট ব্যবহার করতে পারি যেগুলো কুকি ব্যবহার করে আমাদের সেবাগুলো কীভাবে ব্যবহার করেন ব্যবহারকারীরা তা বিশ্লেষণ করতে এবং সেবা ব্যবহার করার সময় আপনার অভিজ্ঞতা উন্নত করতে সাহায্য করে।',
    subTitle1: 'আমরা সংগ্রহ করা ব্যক্তিগত তথ্য',
    subTitle2: 'আমরা কিভাবে ব্যক্তিগত তথ্য ব্যবহার করি',
    subTitle3: 'ব্যক্তিগত তথ্যের প্রকাশ',
    subTitle4: 'আপনার অধিকারসমূহ',
    subTitle5: 'অন্যান্য ওয়েবসাইটের লিঙ্ক',
    subTitle6: 'তথ্যের নিরাপত্তা ও সংরক্ষণ',
    subTitle7: 'গোপনীয়তা নীতির সংশোধন',
    subTitle8: 'আমাদের সাথে যোগাযোগ করার উপায়',
    title: 'গোপনীয়তা নীতি',
    updateTime: 'হাল করা হয়েছে: 15 মার্চ, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'সমস্ত গ্রহণ করুন',
    text: 'আপনার অভিজ্ঞতা উন্নত করতে হলে, আমরা কন্টেন্ট এবং সার্ভিসগুলো ব্যক্তিগতভাবে তৈরি করতে কুকি ব্যবহার করি।',
    title: 'এই ওয়েবসাইট কুকি ব্যবহার করে।',
  },
  slogen: 'সবচেয়ে সহজ AI সহকারী',
  stripe: {
    contact: 'যে কোনো প্রশ্ন থাকলে contact@noam.tools এ আমাদের সাথে যোগাযোগ করুন!',
    fail: {
      btn: 'পুনরায় চেষ্টা করুন',
      text1: 'আপনার পেমেন্ট প্রক্রিয়াকরণ করা যায়নি।',
      text2: 'আপনার সংযোগ চেক করুন এবং আবার চেষ্টা করুন।',
      title: 'পেমেন্ট ব্যর্থ হয়েছে',
    },
    succ: { btn: 'চলো যাই', text1: 'নোয়ামে স্বাগতম', text2: 'শুরু করা যাক!', title: 'অভিনন্দন' },
  },
  terms: {
    block1: 'নোম ব্যবহার করার জন্য ধন্যবাদ!',
    block10:
      '(ক) ফি এবং বিলিং। আপনি প্রযোজ্য মূল্য তালিকা পৃষ্ঠার মূল্য এবং শর্তাবলী অনুসারে বা আমাদের মধ্যে লিখিতভাবে সম্মতিতে সমস্ত ফি ("ফি") পরিশোধ করবেন। আমরা ইনভয়েস জারি করেছি বা পেমেন্ট পেয়েছি তা হলেও মূল্যের ত্রুটি বা ভুল সংশোধন করার অধিকার সংরক্ষণ করি। আপনি সম্পূর্ণ এবং সঠিক বিলিং তথ্য প্রদান করবেন, যার মধ্যে একটি বৈধ এবং অনুমোদিত পেমেন্ট পদ্ধতি অন্তর্ভুক্ত থাকবে। আমরা সম্মতিতে পর্যায়ক্রমিকভাবে আপনার পেমেন্ট পদ্ধতিতে চার্জ করব, তবে আমরা বিলিং তারিখ যুক্তিসঙ্গতভাবে পরিবর্তন করতে পারি। আপনি নোয়াম, এর অ্যাফিলিয়েটস এবং তৃতীয় পক্ষের পেমেন্ট প্রসেসরদের আপনার পেমেন্ট পদ্ধতিতে চার্জ করার অনুমতি দিয়েছেন। আপনার পেমেন্ট ব্যর্থ হলে, আমরা আপনাকে লিখিত নোটিশ প্রদান করব এবং পেমেন্ট পাওয়া না হওয়া পর্যন্ত সার্ভিসে অ্যাক্সেস সাসপেন্ড করতে পারি। এই চুক্তিতে অন্যথায় নির্দেশিত না থাকলে, পেমেন্টগুলো অপ্রত্যাবর্তনীয়।',
    block11:
      '(b) ট্যাক্স। অন্যথায় নির্দেশিত না হলে, ফি-এর মধ্যে কোনো ফেডারেল, রাজ্য, স্থানীয় এবং বিদেশী ট্যাক্স, ডিউটি এবং অনুরূপ মূল্যায়ন ("ট্যাক্স") অন্তর্ভুক্ত থাকে না। আপনার ক্রয়ের সাথে যুক্ত সমস্ত ট্যাক্সের জন্য আপনি দায়ী, যা আমাদের নেট ইনকামের ভিত্তিতে করা ট্যাক্স বাদে যার জন্য আমরা আপনাকে ইনভয়েস করব। আপনি এই জাতীয় ট্যাক্সগুলো তারক্যময়ভাবে পরিশোধ করবেন এবং আমাদেরকে আইনগতভাবে বৈধ গোপনীয়তা বিবৃতি প্রদান করবেন এবং এই জাতীয় ডেটা হ্যান্ডল করার জন্য প্রয়োজনীয় সম্মতি প্রদান করবেন, এবং আপনি আমাদেরকে ওয়ারেন্টি দিয়েছেন যে আপনি প্রযোজ্য আইন অনুসারে এই ডেটা হ্যান্ডল করছেন।',
    block12:
      '(c) মূল্য পরিবর্তন। আমরা আপনার অ্যাকাউন্টের মাধ্যমে এবং/অথবা আমাদের ওয়েবসাইটের মাধ্যমে আপনাকে নোটিফিকেশন পাঠিয়ে আমাদের মূল্য পরিবর্তন করতে পারি। মূল্য বৃদ্ধি পোস্ট করার পরে তা অবিলম্বে কার্যকর হবে। পরিবর্তনের কার্যকর তারিখের পরে আপনার অ্যাকাউন্টের ফি-এর ক্ষেত্রে যেকোনো মূল্য পরিবর্তন প্রযোজ্য হবে।',
    block13:
      '(d) বিরোধ ও বিলম্বিত প্রদান। আপনি যদি কোনো ফি বা ট্যাক্স নিয়ে বিতর্ক করতে চান, তাহলে ইনভয়েসের তারিখের ত্রিশ (30) দিনের মধ্যে contact@noam.tools এ যোগাযোগ করুন।',
    block14:
      '(e) বিনামূল্যে ব্যবহার। ফ্রি ক্রেডিট পাওয়ার জন্য আপনি একাধিক অ্যাকাউন্ট তৈরি করতে পারবেন না। যদি আমরা নির্ধারণ করি যে আপনি বিনামূল্যে ক্রেডিটগুলো সৎপ্রত্যয়ে ব্যবহার করছেন না, তাহলে আমরা আপনাকে স্ট্যান্ডার্ড ফি চার্জ করতে পারি বা সার্ভিসে অ্যাক্সেস প্রদান করা বন্ধ করতে পারি।',
    block15:
      '(ক) গোপনীয়। আপনার নোয়ামের গোপন তথ্য অ্যাক্সেস থাকতে পারে। পরিষেবা ব্যবহারের উদ্দেশ্যে এই শর্তাবলী অনুসারে অনুমোদিতভাবেই আপনি গোপন তথ্য ব্যবহার করতে পারেন। আপনি কোনো তৃতীয় পক্ষের কাছে গোপন তথ্য প্রকাশ করতে পারবেন না, এবং আপনি নিজের একই ধরনের গোপন তথ্য রক্ষা করার মতোই কম নয় এমনভাবে গোপন তথ্য রক্ষা করবেন, কমপক্ষে যুক্তিসঙ্গত সতর্কতার সাথে। গোপন তথ্য হলো নোয়াম দ্বারা গোপন হিসেবে নির্ধারিত অথবা পরিস্থিতিতে যুক্তিসঙ্গতভাবে গোপন হিসেবে বিবেচিত হওয়া উচিত এমন অপ্রাকৃতিক তথ্য, যার মধ্যে সফটওয়্যার, স্পেসিফিকেশন এবং অন্যান্য অপ্রাকৃতিক ব্যবসায় তথ্য অন্তর্ভুক্ত। গোপন তথ্যের মধ্যে নিম্নলিখিত ধরনের তথ্য অন্তর্ভুক্ত নয়: (1) আপনার দোষ ছাড়াই সাধারণভাবে জনসাধারণের কাছে প্রাপ্তযোগ্য হয়ে ওঠে; (2) এই শর্তাবলী অনুসারে প্রাপ্ত করার আগে আপনার কাছে কোনো গোপনীয়তার বাধ্যবাধকতা ছাড়াই রাখা ছিল; (3) কোনো তৃতীয় পক্ষ দ্বারা কোনো গোপনীয়তার বাধ্যবাধকতা ছাড়াই আইনসম্মতভাবে আপনার কাছে প্রকাশ করা হয়েছে; অথবা (4) আপনার দ্বারা গোপন তথ্য ব্যবহার না করে স্বাধীনভাবে তৈরি করা হয়েছে। আইন, আদালত বা অন্যান্য সরকারি আদেশের দ্বারা প্রয়োজন হলে আপনি গোপন তথ্য প্রকাশ করতে পারেন, তবে আপনি নোয়ামকে যুক্তিসঙ্গতভাবে পূর্বে লিখিত নোটিশ দিতে হবেন এবং যতটা সম্ভব, প্রকাশের পরিধি সীমিত করার জন্য যুক্তিসঙ্গত প্রচেষ্টা করবেন, যার মধ্যে প্রকাশের অনুরোধের বিরুদ্ধে আমাদের সহায়তা করা অন্তর্ভুক্ত।',
    block16:
      '(b) নিরাপত্তা। সার্ভিসটি অ্যাক্সেস করা এবং ব্যবহার করার জন্য আপনাকে যুক্তিসঙ্গত এবং উপযুক্ত ব্যবস্থা বাস্তবায়ন করতে হবে। আপনি যদি সার্ভিসটির ব্যবহারের সাথে সম্পর্কিত কোনও দুর্বলতা বা লঙ্ঘন আবিষ্কার করেন, তাহলে আপনাকে অবশ্যই দ্রুত নোয়ামের সাথে যোগাযোগ করতে হবে এবং দুর্বলতা বা লঙ্ঘনের বিশদ বিবরণ প্রদান করতে হবে।',
    block17:
      '((c) ব্যক্তিগত ডেটার প্রক্রিয়াকরণ। আপনি যদি ব্যক্তিগত ডেটা প্রক্রিয়া করতে সার্ভিসটি ব্যবহার করেন, তাহলে আপনাকে আইনগতভাবে পর্যাপ্ত গোপনীয়তা বিবৃতি প্রদান করতে হবে এবং এই ধরনের ডেটা প্রক্রিয়াকরণের জন্য প্রয়োজনীয় সম্মতি প্রাপ্ত করতে হবে, এবং আপনি আমাদের কাছে ضمان্টি দিয়েছেন যে আপনি প্রযোজ্য আইন অনুসারে এই ধরনের ডেটা পরিচালনা করেন।',
    block18:
      '(ক) সমাপ্তি; সাসপেনশন। এই শর্তগুলি সার্ভিসের প্রথম ব্যবহার থেকে কার্যকর হবে এবং সমাপ্ত না হওয়া পর্যন্ত কার্যকর থাকবে। সার্ভিস এবং কন্টেন্টের ব্যবহার বন্ধ করে আপনি যেকোনো কারণে যেকোনো সময়ে এই শর্তগুলি বাতিল করতে পারেন। আমরা যেকোনো কারণে পূর্ব নোটিশ সহ এই শর্তগুলি বাতিল করতে পারি। আপনি যদি বিভাগ 2 (ব্যবহারের প্রয়োজনীয়তা), বিভাগ 5 (গোপনীয়তা, নিরাপত্তা এবং ডেটা সুরক্ষা), বিভাগ 8 (বিরোধ সমাধান) বা বিভাগ 9 (সাধারণ শর্তাবলী) কে মূলত লঙ্ঘন করেন, অথবা আমাদের নিয়ন্ত্রণের বাইরে থাকা কোনো তৃতীয় পক্ষ প্রযুক্তি প্রদানকারীর সাথে আমাদের সম্পর্ক পরিবর্তন হয়, অথবা আইন বা সরকারি অনুরোধ মেনে চলার জন্য আমরা আপনাকে নোটিফাই করে এই শর্তগুলি তাৎক্ষণিকভাবে বাতিল করতে পারি। আপনি যদি এই শর্তগুলি মেনে না চলেন, অথবা আপনার ব্যবহার আমাদের বা কোনো তৃতীয় পক্ষের কাছে নিরাপত্তা ঝুঁকি সৃষ্টি করে, অথবা আমরা সন্দেহ করি যে আপনার ব্যবহার প্রতারকতময় বা আমাদের বা কোনো তৃতীয় পক্ষকে দায়বদ্ধতার সামনে ফেলতে পারে তাহলে আমরা সার্ভিসে আপনার অ্যাক্সেস সাসপেন্ড করতে পারি।',
    block19:
      '(খ) সমাপ্তির প্রভাব। সমাপ্তির পরে, আপনি পরিষেবাটির ব্যবহার বন্ধ করবেন এবং আমাদের নির্দেশ অনুসারে যেকোনো গোপন তথ্য দ্রুত ফেরত দেবেন বা ধ্বংস করবেন। এই শর্তাদের বিধানগুলো যেগুলোর প্রকৃতি অনুসারে সমাপ্তি বা মেয়াদ উত্তীর্ণ হওয়ার পরেও বেঁচে থাকা উচিত, যার মধ্যে 3 এবং 5-9 সেকশন অন্তর্ভুক্ত কিন্তু সीमিত নয়, সেগুলো বেঁচে থাকবে।',
    block2:
      'এই ব্যবহার শর্তগুলি নোয়ামের সার্ভিসের ব্যবহারের ক্ষেত্রে প্রযোজ্য, যার মধ্যে রয়েছে আমাদের অ্যাপ্লিকেশন প্রোগ্রামিং ইন্টারফেস, সফটওয়্যার, টুল, ডেভেলপার সার্ভিস, ডেটা, ডকুমেন্টেশন এবং ওয়েবসাইট (একত্রে "সার্ভিসेज" হিসেবে উল্লেখ করা হয়েছে)। আমাদের সার্ভিস ব্যবহার করে, আপনি এই শর্তগুলি মেনে চলার সম্মতি দিয়েছেন। আমাদের গোপনীয়তা নীতি ব্যাখ্যা করে যে আমরা কীভাবে ব্যক্তিগত তথ্য সংগ্রহ করি এবং ব্যবহার করি।',
    block20:
      'ক্ষতিপূরণ। পরিষেবাটির ব্যবহারের ফলে বা এর সাথে সম্পর্কিত যেকোনো দাবি, ক্ষতি এবং খরচ (অ্যাটর্নি ফি সহ), আপনার কন্টেন্ট, পরিষেবার সাথে সম্পর্কিত পণ্য বা পরিষেবার ব্যবহার, এবং এই শর্তাবলী বা প্রযোজ্য আইন লঙ্ঘনের কারণে আমাদের, আমাদের সাথী সংস্থাগুলো এবং আমাদের কর্মীদেরকে নিরাপদ রাখবেন, তাদেরকে ক্ষতিপূরণ দেবেন এবং তাদের প্রতি প্রতিরক্ষা করবেন।',
    block21:
      '(খ) অস্বীকারোক্তি। সার্ভিসটি "যেমন আছে" প্রদান করা হয়। আইন দ্বারা অনুমোদিত পরিমাণে, আমরা এবং আমাদের অ্যাফিলিয়েটস এবং লাইসেন্সররা সার্ভিস সম্পর্কে কिसी ধরণের প্রতিনিধিত্ব বা গ্যারান্টি দিই না এবং কোনো গ্যারান্টি দিই না, যার মধ্যে রয়েছে কিন্তু সীমাবদ্ধ নয় ব্যবসায়িকতার গ্যারান্টি, একটি নির্দিষ্ট উদ্দেশ্যের জন্য উপযুক্ততা, সন্তোষজনক গुणমান, অ-লঙ্ঘন, এবং শান্ত উপভোগ, এবং লেনদেনের প্রক্রিয়া বা ব্যবসার ব্যবহার থেকে উদ্ভূত যেকোনো গ্যারান্টি। আমরা গ্যারান্টি দিই না যে সার্ভিসটি অবিরত, সঠিক বা ত্রুটি-মুক্ত হবে, বা যে কোনো কন্টেন্ট নিরাপদ, হারানো না বা পরিবর্তিত হবে না।',
    block22:
      '(c) দায় সীমাবদ্ধতা। আমরা, আমাদের অ্যাফিলিয়েটস বা আমাদের লাইসেন্সদাতারা কোনো পরোক্ষ, আনুষঙ্গিক, বিশেষ, পরিণামমূলক বা শাস্তিমূলক ক্ষতির জন্য দায়ী হবেন না, যার মধ্যে লাভের ক্ষতি, খ্যাতির ক্ষতি, ব্যবহারের ক্ষতি, ডেটার ক্ষতি বা অন্যান্য মূর্তহীন ক্ষতি অন্তর্ভুক্ত, এমনকি যদি আমাদের এই ধরনের ক্ষতির সম্ভাবনা সম্পর্কে সুপারিশ করা হয়েছিলেও। এই শর্তাদের অধীনে, আমাদের মোট দায় দাবির আগের বারো (12) মাসে আপনি সার্ভিসটির কাছে পরিশোধ করা ফি বা একশো মার্কিন ডলার ($100) এর মধ্যে যা বড়, তার থেকে বেশি হবে না। এই বিভাগের সীমাবদ্ধতাগুলি প্রযোজ্য আইন দ্বারা অনুমোদিত সর্বাধিক সীমার মধ্যে প্রযোজ্য।',
    block23:
      'শর্তাবলী এবং পরিষেবাগুলির আপনার ব্যবহার মার্কিন যুক্তরাষ্ট্রের আইন দ্বারা নিয়ন্ত্রিত হয়, তবে মার্কিন আইনের দ্বন্দ্ব নিয়ম ব্যতীত। অ্যাপ্লিকেশনটির আপনার ব্যবহার স্থানীয়, রাজ্য, জাতীয় বা আন্তর্জাতিক অন্যান্য আইনের অধীনও হতে পারে। এই শর্তাবলীর সাথে সম্পর্কিত যেকোনো আইনি ক্রিয়া বা প্রক্রিয়া একচেটিয়াভাবে মার্কিন যুক্তরাষ্ট্রের আদালতে আনা হবে, এবং আপনি এই ধরনের আদালতের ব্যক্তিগত অধিকার ক্ষেত্রের অধীনে সমর্পণ করতে সম্মত হন।',
    block24:
      'পক্ষদের সম্পর্ক। নোয়াম এবং আপনি স্বাধীন কর্মকার, এবং অন্য পক্ষের পূর্ব প্রাকটনিক লিখিত সম্মতি ছাড়া কোনো পক্ষই অন্য পক্ষের প্রতিনিধিত্ব করতে বা বাধ্য করতে বা অন্য পক্ষের জন্য দায়িত্ব গ্রহণ করতে সক্ষম নয়।',
    block25:
      '(b) ব্র্যান্ড ব্যবহার। আমাদের পূর্বের লিখিত সম্মতি ছাড়া আপনি নোয়াম বা এর কোনো সাথীসংস্থার নাম, লোগো বা ট্রেডমার্ক ব্যবহার করতে পারবেন না।',
    block26:
      'যদি এই শর্তাবলীর কোনো বিধানকে অবৈধ, অকানুনী বা প্রয়োগযোগ্য নয় বলে নির্ধারিত করা হয়, তাহলে বাকি বিধানগুলো সম্পূর্ণ কার্যকরী ও প্রযোজ্য থাকবে।',
    block3:
      'যদি আপনি 18 বছরের কম বয়সে থাকেন, তাহলে সার্ভিস ব্যবহার করার জন্য আপনাকে অবশ্যই আপনার পিতা-মাতা বা আইনি অভিভাবকের অনুমতি প্রাপ্ত করতে হবে। যদি আপনি অন্য ব্যক্তি বা সংস্থার পক্ষে সার্ভিস ব্যবহার করছেন, তাহলে আপনাকে অবশ্যই তাদের পক্ষে এই শর্তগুলি গ্রহণ করার অনুমতি থাকতে হবে। একটি অ্যাকাউন্ট রেজিস্টার করতে আপনাকে অবশ্যই সঠিক এবং সম্পূর্ণ তথ্য প্রদান করতে হবে। আপনি আপনার সংস্থার বাইরের কারো কাছে আপনার অ্যাক্সেস ক্রেডেনশিয়াল বা অ্যাকাউন্ট প্রদান করতে পারবেন না, এবং আপনার ক্রেডেনশিয়াল ব্যবহার করে সক্রিয় করা সমস্ত কার্যকলাপের জন্য আপনি দায়ী।',
    block4:
      '(ক) সার্ভিসের ব্যবহার। আপনি এই শর্তাদের অধীনে সার্ভিসটি অ্যাক্সেস করতে পারেন, এবং আমরা আপনাকে সার্ভিসটি ব্যবহার করার একটি অ-একচেটিযুক্ত অধিকার দিয়েছি। সার্ভিসটি ব্যবহার করার সময়, আপনি এই শর্তাদের এবং সমস্ত প্রযোজ্য আইনের পালন করবেন। আমরা এবং আমাদের অ্যাফিলিয়েটস সার্ভিসের সমস্ত অধিকার, শিরোনাম এবং স্বার্থের মালিক।',
    block5:
      '(b) ফিডব্যাক। আমরা ফিডব্যাক, মন্তব্য, ধারণা, পরামর্শ এবং উন্নতির স্বাগত করি। আপনি যদি এই ধরনের কোনো বিষয় সরবরাহ করেন, তাহলে আমরা এটি কোনো সীমাবদ্ধতা ছাড়া এবং আপনার কাছে কোনো ক্ষতিপূরণ ছাড়া ব্যবহার করতে পারি।',
    block6:
      '(c) নিষিদ্ধতা। আপনি পারবেন না: (1) পরিষেবাটি এমনভাবে ব্যবহার করা যা অন্যের কোনো অধিকার লঙ্ঘন করে, অপব্যবহার করে বা লঙ্ঘন করে; (2) রিভার্স ইঞ্জিনিয়ার, ডিকম্পাইল, ডিস্যাসেম্বল, অনুবাদ করা বা অন্যথায় পরিষেবার মডেল, অ্যালগরিদম এবং সিস্টেমের উৎস কোড বা অন্তর্নিহিত কম্পোনেন্ট আবিষ্কার করার চেষ্টা করা (যদি প্রযোজ্য আইন দ্বারা এই ধরনের নিষিদ্ধতা নিষিদ্ধ না হয়); (3) নোয়ামের সাথে প্রতিযোগিতা করার মডেল তৈরি করতে পরিষেবার আউটপুট ব্যবহার করা; (4) API এর মাধ্যমে অনুমোদিত না হলে কোনো স্বয়ংক্রিয় বা প্রোগ্রামিং পদ্ধতি ব্যবহার করে পরিষেবা থেকে ডেটা বা আউটপুট বের করা যা স্ক্র্যাপিং, ওয়েব হার্ভেস্টিং বা ওয়েব ডেটা এক্সট্রাকশন সহ; (5) যখন পরিষেবার আউটপুট কৃত্রিমভাবে তৈরি করা হয় না তখন তাকে কৃত্রিমভাবে তৈরি করা হিসেবে প্রতিনিধিত্ব করা বা অন্যথায় আমাদের ব্যবহার নীতি লঙ্ঘন করা; (6) আমাদের পূর্বের সম্মতি ছাড়াই API কী ক্রয়, বিক্রি বা স্থানান্তর করা; বা (7) 13 বছরের কম বয়সী বাচ্চাদের বা ডিজিটাল সম্মতির প্রযোজ্য বয়সের কোনো ব্যক্তির ব্যক্তিগত তথ্য আমাদেরকে প্রদান করা। আপনি আমাদের ডকুমেন্টেশনের যেকোনো রেট লিমিট এবং অন্যান্য প্রয়োজনীয়তা মেনে চলবেন।',
    block7:
      '(d) তৃতীয়-পক্ষ সার্ভিসेज। সার্ভিসের সাথে যুক্ত যেকোনো তৃতীয়-পক্ষ সফটওয়্যার, সার্ভিস বা অন্যান্য পণ্য তাদের নিজস্ব শর্তাবলীর অধীনে পরিচালিত হয়, এবং তৃতীয়-পক্ষের পণ্যের জন্য আমরা দায়ী নই।',
    block8:
      '(ক) আপনার কন্টেন্ট। আপনি সার্ভিসে ইনপুট ("ইনপুট") প্রদান করতে পারেন এবং ইনপুটের ভিত্তিতে তৈরি ও রিটার্ন করা আউটপুট ("আউটপুট") প্রাপ্ত করতে পারেন (একত্রে "কন্টেন্ট" হিসেবে উল্লেখ করা হয়)। পক্ষগুলির মধ্যে, এবং প্রযোজ্য আইন দ্বারা অনুমোদিত মাত্রায়, আপনি সমস্ত ইনপুটের মালিক। নোয়াম সার্ভিস প্রদান ও রক্ষা করতে, প্রযোজ্য আইন মেনে চলতে এবং আমাদের নীতি লागু করতে কন্টেন্ট ব্যবহার করতে পারে। আপনি কন্টেন্টের জন্য দায়ী, যার মধ্যে এটি কোনো প্রযোজ্য আইন বা এই শর্তগুলি লঙ্ঘন করে না তা নিশ্চিত করা অন্তর্ভুক্ত।',
    block9:
      '(b) নির্ভুলতা। কৃত্রিম বুদ্ধি এবং মেশিন লার্নিং দ্রুত বিকশিত হচ্ছে গবেষণার ক্ষেত্র। আমরা ক্রমাগত আমাদের সার্ভিসকে আরও নির্ভুল, নির্ভরযোগ্য, সুরক্ষিত এবং উপকারী করতে উন্নত করতে চেষ্টা করি। মেশিন লার্নিংয়ের সম্ভাব্যতামূলক প্রকৃতির কারণে, আমাদের সার্ভিস ব্যবহার করলে কিছু ক্ষেত্রে ভুল আউটপুট দেওয়া হতে পারে, যা প্রকৃতির ব্যক্তি, স্থান বা তথ্যকে সঠিকভাবে প্রতিফলিত নাও করতে পারে। আপনার ব্যবহারের ক্ষেত্রের ভিত্তিতে যেকোনো আউটপুটের নির্ভুলতা যথাযথভাবে মূল্যায়ন করা উচিত, যার মধ্যে ম্যানুয়ালি আউটপুট পর্যালোচনা করা অন্তর্ভুক্ত।',
    subTitle1: 'নিবন্ধন এবং অ্যাক্সেস',
    subTitle10: 'পৃথকযোগ্যতা',
    subTitle2: 'ব্যবহারের প্রয়োজনীয়তা',
    subTitle3: 'কন্টেন্ট',
    subTitle4: 'ফি এবং পেমেন্ট',
    subTitle5: 'গোপনীয়তা, নিরাপত্তা, এবং ডেটা সুরক্ষা',
    subTitle6: 'শর্ত ও শেষ',
    subTitle7: 'ক্ষতিপূরণ; অস্বীকারপত্র; দায় সীমাবদ্ধতা',
    subTitle8: 'শাসন কানুন ও কর্তৃকতা',
    subTitle9: 'সাধারণ শর্তাবলী',
    title: 'সেবার শর্তাবলী',
    updateTime: 'আপডেট করা হয়েছে: 15 মার্চ, 2024',
  },
  trialModal: {
    btn: 'এখনই শুরু করুন（শুধুমাত্র $0.99）',
    chat: 'চ্যাটপিডিএফ',
    desc1: 'আপনার ট্রায়াল শেষ হওয়ার পরে, আপনাকে বার্ষিক 180 ডলার ফি চার্জ করা হবে',
    desc2: 'যে কোনো সময় বাতিল করুন',
    focus: 'কেন্দ্রীভূত করা',
    hover: 'হোভার অনুবাদ',
    image: 'ছবি অনুবাদ',
    installBtn: 'এখনই ইনস্টল করুন تا আপনার উপহার পান করুন',
    memo: 'ফেভারিটস ম্যানেজমেন্ট',
    pdf: 'PDF সমান্তরাল অনুবাদ',
    realtime: 'তাত্ক্ষণিক অনুবাদ',
    select: 'শব্দ নির্বাচন অনুবাদ',
    title: 'স্বাগত উপহার',
    trialText: '৭-দিনের ট্রায়াল',
    video: 'ভিডিও অনুবাদ',
    videoSummary: 'ভিডিও সারাংশ',
    web: 'সমান্তরাল অনুবাদ',
    webSummary: 'ওয়েব সারসংক্ষেপ',
  },
  upgradeModal: {
    btn: 'এখন আপগ্রেড করুন',
    chat: {
      free: 'আপনি ChatPDF লিমিটে পৌঁছেছেন',
      pro: 'আপনি এই মাসের জন্য ChatPDF সীমাটি পৌঁছেছেন',
    },
    contactStr:
      ' পরবর্তী রিসেটের জন্য অপেক্ষা করুন, অথবা contact@noam.tools এ আমাদের সাথে যোগাযোগ করুন।',
    limitAlertStr: 'আপনি আপনার ফ্রি প্ল্যানের সীমা পৌঁছেছেন। অব্যাহত রাখতে আপগ্রেড করুন।',
    more: 'প্ল্যান দেখুন',
    pageLimit: { free: 'আপনি পিডিএফ পৃষ্ঠা সীমা পর্যন্ত পৌঁছেছেন' },
    title: 'নোটিশ',
    upgradeAlertStr: 'আপনার ফ্রি প্ল্যানের লিমিটে পৌঁছেছেন। অব্যাহত রাখতে আপগ্রেড করুন।',
    upload: {
      free: 'আপনি আপনার পিডিএফ অনুবাদ সীমা পর্যন্ত পৌঁছেছেন',
      pro: 'আপনি এই মাসের জন্য আপনার পিডিএফ অনুবাদ সীমা পৌঁছেছেন',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'এখনই যোগ দিন',
      label: 'নতুন ব্যবহারকারীর সুবিধা:',
      remain: 'শুধুমাত্র 30 বাকি',
      text: 'শুধুমাত্র 100টি স্পট উপলব্ধ! এখনই আপনার টেকে নিন!',
    },
  },
  aiPdfTranslator: {
    title: 'ফ্রি AI পিডিএফ ট্রান্সলেটর: যেকোন ভাষায় তুলনা সহ পিডিএফ অনুবাদ করুন',
    desc: 'এআই দিয়ে সহজেই পিডিএফ ফাইলগুলো যেকোনো ভাষায় অনুবাদ করুন। মূল ও অনুবাদিত টেক্সটকে পাশাপাশি তুলনা করুন, দ্রুত এবং বিনামূল্যে।',
    keywords:
      'জিপিটি-৪, এআই অ্যাসিস্ট্যান্ট, ট্রান্সলেশন, সামারি (সারসংক্ষেপ), ফোকাস, চ্যাটপিডিএফ, মেমো, দক্ষতা',
    sourceToTarget: {
      title: 'ফ্রি পিডিএফ ট্রান্সলেশন টুল: {{source}} কে {{target}} এ ফ্রি ট্রান্সলেট করুন',
      desc: 'কোনো উৎস ভাষা থেকে আপনার পছন্দের ভাষায় আপনার পিডিএফ ফাইলগুলো বিনামূল্যে অনুবাদ করুন। উন্নত AI দ্বারা চালিত দ্রুত, সঠিক এবং নিরাপদ পিডিএফ অনুবাদ।',
    },
    headerIntroduce: {
      title: 'নোয়াম: শুধুমাত্র অনলাইন অনুবাদের চেয়ে বেশি',
      introduce1: {
        title: 'নোয়াম · পিডিএফ রিডার',
        desc: '✨পাশাপাশি অনুবাদ + AI প্রশ্ন-উত্তর। দ্রুত এবং সঠিকভাবে পিডিএফ ফাইলগুলো আপনার লক্ষ্য ভাষায় অনুবাদ করুন। সামগ্রীর বিষয়ে অবাধে প্রশ্ন করুন যাতে আপনার পিডিএফ ফাইলগুলোর গভীর বোধগম্যতা অর্জন করুন।',
      },
      introduce2: {
        title: 'নোয়াম · সাইড-বাই-সাইড ট্রান্সলেশন এক্সটেনশন',
        desc: '👏আপনার সমস্ত ওয়েবপেজ অনুবাদ প্রয়োজনীয়তা সমাধান করুন:',
        detail1: { title: 'ওয়েবপেজ অনুবাদ:', desc: 'পাশাপাশি দ্বিভাষিক দৃশ্য' },
        detail2: { title: 'শব্দ অনুবাদ:', desc: 'এক ক্লিক দ্রুত অনুবাদ' },
        detail3: { title: 'তাত্ক্ষণিক অনুবাদ:', desc: 'শব্দ বা বাক্যগুলো সাথে সাথে অনুবাদ করুন।' },
        detail4: {
          title: 'ছবি অনুবাদ:',
          desc: 'ছবিগুলো প্রশ্নানুবাদিত ছবি দিয়ে প্রতিস্থাপন করুন।',
        },
        detail5: { title: 'ভিডিও অনুবাদ:', desc: 'সেরা দেখার জন্য দ্বিভাষিক সাবটাইটেল।' },
        footer: 'স্মার্টার ট্রান্সলেশনের জন্য আরও AI-সমর্থিত রিডিং ফিচারগুলো অনুভব করুন!',
      },
    },
    subtitle: 'ফ্রি পিডিএফ অনলাইন অনুবাদ করুন',
    introduce: {
      module1: {
        detail1: {
          title: 'রিয়েল-টাইম সাইড-বাই-সাইড পিডিএফ অনুবাদ',
          desc1: 'অসাথে সংশ্লিষ্ট, পাশাপাশি লেআউটে মূল এবং অনুবাদকৃত সামগ্রী প্রদর্শন করুন',
          desc2: 'সিঙ্ক্রোনাইজড স্ক্রোলিংয়ের মাধ্যমে সহজেই উভয় সংস্করণ তুলনা করুন',
          desc3: 'সামঞ্জস্যপূর্ণ রিডিং অভিজ্ঞতার জন্য অভিন্ন ফরম্যাটিং বজায় রাখুন',
        },
        detail2: {
          title: 'সঠিক সামগ্রী সারিবদ্ধকরণ ও যাচাই',
          desc1: 'সহজ যাচাই করার জন্য উৎস ও অনুবাদিত পাঠ্যের মধ্যে নিখুঁত সামঞ্জস্য',
          desc2: 'উভয় সংস্করণে সামগ্রীর প্রতিটি অংশ ঠিকভাবে মেলে',
          desc3: 'বিশ্বাসযোগ্য ফলাফলের জন্য দ্রুত অনুবাদের অসামঞ্জস্য চিহ্নিত করুন এবং সমাধান করুন',
        },
      },
      module2: {
        detail1: {
          title: 'সুনির্দিষ্ট অনুবাদের জন্য একাধিক উন্নত AI মডেল',
          desc1:
            'আপনার অনুবাদ প্রয়োজনীয়তার সাথে মেলানোর জন্য শীর্ষস্থানীয় AI মডেলগুলি থেকে নির্বাচন করুন',
          desc2: 'বিভিন্ন দস্তাবেজ প্রকার এবং শিল্পের জন্য সর্বোত্তম ফলাফল নিশ্চিত করুন',
          desc3: 'নমনীয় মডেল বিকল্পগুলি প্রতিটি পরিস্থিতির জন্য তৈরি করা সমাধান প্রদান করে',
        },
        detail2: {
          title: 'প্রতিটি কন্টেন্ট টাইপের জন্য উন্নত AI অনুবাদ',
          desc1: 'আমাদের শক্তিশালী AI মডেল উচ্চ নির্ভুলতা এবং প্রাকৃতিক ভাষা বোঝার নিশ্চয়তা দেয়',
          desc2: 'প্রযুক্তিগত, একাডেমিক এবং সৃজনশীল নথিগুলো সহজেই পরিচালনা করে।',
          desc3: 'আপনার সমস্ত অনুবাদ প্রয়োজনের জন্য নির্ভরযোগ্য ফলাফল প্রদান করে',
          desc4: 'অপ্টিমাল পারফরম্যান্সের জন্য বিভিন্ন কন্টেন্ট টাইপের সাথে বুদ্ধিমানভাবে অভিযোজন',
        },
      },
      module3: {
        detail1: {
          title: 'বুদ্ধিমান দস্তু মিথস্ক্রিয়া',
          desc1: 'উন্নত AI ব্যবহার করে আপনার PDF এবং প্রেজেন্টেশন ফাইলের সাথে সহজেই চ্যাট করুন',
          desc2:
            'ডকুমেন্টের বিষয়বস্তু সম্পর্কে তাত্ক্ষণিকভাবে প্রশ্ন করুন এবং সঠিক উত্তর পান করুন',
          desc3: 'দীর্ঘ দস্তাবেজের জন্য দ্রুত সংক্ষিপ্ত সারাংশ তৈরি করুন',
        },
        detail2: {
          title: 'গভীর সামগ্রী বিশ্লেষণ এবং নিরবচ্ছিন্ন সংযুক্তি',
          desc1: 'এআই-চালিত বোধের মাধ্যমে মূল তথ্য বের করুন এবং জটিল ডেটা বিশ্লেষণ করুন',
          desc2: 'প্রযুক্তিগত, একাডেমিক বা সৃজনশীল সামগ্রী সম্পর্কে অন্তর্দৃষ্টি লাভ করুন',
          desc3:
            'পূর্ণাঙ্গ ডকুমেন্ট ম্যানেজমেন্ট সলিউশনের জন্য আমাদের পিডিএফ ট্রান্সলেটরের সাথে নিখুঁতভাবে একত্রিত হয়',
        },
      },
      module4: {
        detail1: {
          title: 'পিডিএফ অনুবাদের বাইরে: অল-ইন-ওয়ান ওয়েবপেজ অনুবাদ সমাধান',
          desc: 'প্রতিটি অনলাইন রিডিং সিনারিওর জন্য ডিজাইন করা আমাদের শক্তিশালী সাইড-বাই-সাইড ট্রান্সলেশন এক্সটেনশন আবিষ্কার করুন।',
          desc1: 'ওয়েবপেজ অনুবাদ: সিঙ্ক্রোনাইজড সাইড-বাই-সাইড ভিউ সহ দ্বিভাষিক সামগ্রী উপভোগ করুন',
          desc2: 'শব্দ অনুবাদ: এক ক্লিকে হাইলাইট করা শব্দগুলো তাত্ক্ষণিকভাবে অনুবাদ করুন',
          desc3:
            'তাত্ক্ষণিক অনুবাদ: দ্রুত বোঝার জন্য যেকোনো টেক্সট বা বাক্যকে তাত্ক্ষণিকভাবে অনুবাদ করুন',
          desc4:
            'ইমেজ ট্রান্সলেশন: স্বয়ংক্রিয়ভাবে মূল চিত্রগুলো প্রতিস্থাপন করুন অনুবাদকৃত সংস্করণগুলো দিয়ে',
          desc5: 'ভিডিও অনুবাদ: উন্নত অভিজ্ঞতার জন্য দ্বিভাষিক সাবটাইটেল সহ ভিডিও দেখুন',
        },
      },
    },
    question: {
      title: 'সবচেয়ে বেশি জিজ্ঞাসিত প্রশ্নাবলী',
      answer1: {
        title: 'নোয়াম পিডিএফ ট্রান্সলেটর পিডিএফ অনুবাদের জন্য বিনামূল্যে ব্যবহার করা যায় কি?',
        content:
          'হ্যাঁ, আপনি সাইডার পিডিএফ ট্রান্সলেটর দিয়ে বিনামূল্যে পিডিএফ ফাইল অনুবাদ করতে পারেন! আমরা 5,000 টোকেনের একটি বিনামূল্যে কোটা অফার করছি, যা বাজারে সাধারণত পাওয়া বেশিরভাগ পিডিএফ ডকুমেন্ট অনুবাদ করতে যথেষ্ট। যদি আপনার বড় ফাইল অনুবাদ করতে দরকার হয় বা উন্নত বৈশিষ্ট্যগুলি প্রয়োজন হয়, তাহলে আপনি আরও বেশি ক্ষমতার জন্য আমাদের প্রিমিয়াম প্ল্যানে আপগ্রেড করতে পারেন।',
      },
      answer2: {
        title: 'নোয়াম পিডিএফ ট্রান্সলেটর কতটা সঠিক?',
        content:
          'নোয়াম পিডিএফ ট্রান্সলেটর উন্নত এআই প্রযুক্তি ব্যবহার করে এবং আপনার দস্তাবেজের প্রসঙ্গকে গভীরভাবে বোঝার মাধ্যমে অত্যন্ত সঠিক অনুবাদ প্রদান করে। যদিও কোনো স্বয়ংক্রিয় অনুবাদ নিখুঁত নয়, তবে আমাদের সাইড-বাই-সাইড ডিসপ্লে আপনাকে প্রতিটি অনুবাদ সহজেই পর্যালোচনা এবং সংশোধন করতে দেয়, যা নিশ্চিত করে যে চূড়ান্ত ফলাফল আপনার গुणস्तरের প্রত্যাশা মেটায়। নোয়ামের সাথে নির্ভরযোগ্য এবং সুনির্দিষ্ট পিডিএফ অনুবাদের অভিজ্ঞতা লাভ করুন।',
      },
      answer3: {
        title: 'আমি স্ক্যান করা পিডিএফ অনুবাদ করতে পারি কি?',
        content:
          'হ্যাঁ, আপনি আমাদের বিল্ট-ইন OCR (অপটিক্যাল ক্যারেক্টার রিকগনিশন) প্রযুক্তির মাধ্যমে স্ক্যান করা PDF-গুলো অনুবাদ করতে পারেন। আমাদের সিস্টেম স্বয়ংক্রিয়ভাবে স্ক্যান করা নথি এবং ইমেজ-ভিত্তিক PDF থেকে টেক্সট বের করে, তারপর আপনার জন্য সামগ্রী অনুবাদ করে। এটি নিশ্চিত করে যে এমনকি সম্পাদনাযোগ্য নয় বা শুধুমাত্র ইমেজযুক্ত PDF-গুলোও সঠিকভাবে অনুবাদ করা যেতে পারে।',
      },
      answer4: {
        title: 'অনুবাদ করতে কত সময় লাগে?',
        content:
          'অনুবাদ দ্রুত এবং কার্যকর—বেশিরভাগ নথি সেকেন্ড থেকে কয়েক মিনিটের মধ্যে প্রক্রিয়া করা হয়, যা তাদের দৈর্ঘ্য এবং জটিলতার উপর নির্ভর করে। উদাহরণস্বরূপ, একটি স্ট্যান্ডার্ড 10-পৃষ্ঠার পিডিএফ অনুবাদ করতে সাধারণত 2 মিনিটেরও কম সময় লাগে। আপনার সমস্ত নথি অনুবাদ প্রয়োজনের জন্য দ্রুত টার্নারাউন্ড সময় উপভোগ করুন!',
      },
      answer5: {
        title: 'আমি পড়ার জন্য সাইড-বাই-সাইড ভিউ রাখতে পারি কি?',
        content:
          'হ্যাঁ, আপনি সর্বদা আপনার নথিগুলো পাশাপাশি পড়তে পারেন। এই লেআউটটি আপনাকে মূল এবং অনুবাদকৃত সামগ্রী সহজেই তুলনা করতে দেয়, যা একটি মসৃণ এবং কার্যকর পড়ার অভিজ্ঞতা নিশ্চিত করে।',
      },
    },
    freeTrial: 'ফ্রি ট্রায়াল',
    toLanguage: { title: 'পিডিএফ এআই ট্রান্সলেশন পেয়ারস', item: '{{সোর্স}} থেকে {{টার্গেট}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'ব্লগ',
      button: 'এখন অনুবাদ করুন',
      pricing: 'মূল্য নির্ধারণ',
      faq: 'সচরাচর জিজ্ঞাসা',
      features: 'বৈশিষ্ট্যসমূহ',
    },
    hero: {
      upload: {
        title: 'আপনার PDF আপলোড করুন',
        highlight: 'ব্রাউজ করুন',
        max: 'ম্যাক্স',
        desc: 'অথবা টেনে ছেড়ে দিন',
      },
      title: 'ফ্রি পিডিএফ ট্রান্সলেটর',
      to: 'এবং',
      pill: 'এআই-চালিত পিডিএফ ট্রান্সলেটর',
      model: 'জিপিটি-৪ এবং ক্লড',
      support: 'OCR সমর্থন',
      desc: 'তাত্ক্ষণিক, সঠিক অনুবাদ যা মূল লেআউট সংরক্ষণ করে। নোয়াম AI OCR এবং সাইড-বাই-সাইড ভিউ সমর্থন করে।',
      free: 'ফ্রি ট্রায়াল',
      translated: 'নোয়াম দ্বারা অনুবাদ করা হয়েছে',
      complete: 'অনুবাদ সম্পন্ন',
    },
    ticker: {
      pdf: 'পিডিএফ অনুবাদ',
      ocr: 'OCR প্রযুক্তি',
      format: 'ফরম্যাট রিটেনশন',
      multi: 'বহুভাষিক',
      side: 'একসাথে',
      chat: 'PDF-এর সাথে চ্যাট করুন',
      secure: 'নিরাপদ ও ব্যক্তিগত',
      web: 'ওয়েব অনুবাদ',
    },
    comparison: {
      bad: {
        title: 'স্ট্যান্ডার্ড ট্রান্সলেশন',
        head: 'ফরম্যাটিং এবং প্রসঙ্গ হারানো হয়েছে',
        text1: 'ত্রুটি: লেআউট ভেঙে গেছে। ছবিগুলো ভুল জায়গায়।',
        text2: 'টেক্সট ওভারল্যাপ করছে এবং ফন্টগুলো সামঞ্জস্যহীন। পড়ার জন্য কঠিন এবং অপ্রফেশনাল...',
      },
      dump: { title: 'সাধারণ পাঠ্য ডাম্প' },
      good: {
        title: 'নোয়াম এআই অনুবাদ',
        tag: 'সম্পূর্ণ ফলাফল',
        sub: 'পারফেক্ট ফরম্যাটিং, প্রসঙ্গ সচেতন',
      },
      title: 'নোম AI কেন বেছে নিন?',
      desc: 'কপি-পেস্ট ট্রান্সলেশনের সাথে সংগ্রাম করা বন্ধ করুন। স্ট্যান্ডার্ড টুলস এবং আমাদের AI-চালিত প্রসঙ্গ-সম্মত ট্রান্সলেশনের মধ্যে পার্থক্যটি অভিজ্ঞ করুন।',
    },
    showcase: {
      kicker: 'সমর্থিত দলিলাবলী',
      title1: 'যে কোনো নথি',
      title2: 'যেকোনো ভাষা',
      carousel2: 'স্থাপত্য',
      carousel1: 'শিল্প',
      carousel3: 'একাডেমিক জার্নাল',
      note: 'প্রযুক্তিগত, একাডেমিক এবং সৃজনশীল নথিগুলো সহজেই পরিচালনা করুন।',
      carousel4: 'ঔষধ',
      carousel5: 'অর্থনীতি',
      carousel6: 'আইন',
      carousel7: 'কন্ট্রাক্ট',
      carousel8: 'নীতি',
    },
    features: {
      big: {
        title: 'উন্নত এআই মডেল (GPT-4, ক্লোড)',
        desc: 'আপনার অনুবাদ প্রয়োজনীয়তার সাথে মেলানোর জন্য শীর্ষস্থানীয় AI মডেল থেকে বেছে নিন। বিভিন্ন ধরনের নথির জন্য оп্টিমাল ফলাফল নিশ্চিত করুন।',
      },
      grid1: {
        title: 'OCR সমর্থন',
        desc: 'স্ক্যান করা পিডিএফ এবং ইমেজ থেকে তাত্ক্ষণিকভাবে টেক্সট বের করুন এবং অনুবাদ করুন।',
      },
      grid2: {
        title: 'হাই-রেজ এক্সপোর্ট',
        desc: 'মূল লেআউট সহ পিডিএফ ফরম্যাটে আপনার অনুবাদকৃত ডকুমেন্ট ডাউনলোড করুন।',
      },
      grid3: {
        title: 'সাইড-বাই-সাইড তুলনা',
        desc: 'মূল এবং অনুবাদিত পাঠ্যের তুলনা করার জন্য সিঙ্ক্রোনাইজড স্ক্রোলিং।',
      },
      title1: 'শুধুমাত্র অনুবাদই নয়',
      title2: 'এটি একটি বিপ্লব',
      line1: 'প্রযুক্তিগত পেপার.pdf',
      line2: 'ভাষা সনাক্ত করা হচ্ছে: ইংরেজি...',
      line3: 'মডেল: GPT-4o (উচ্চ নির্ভুলতা)',
      line4: 'অনুবাদ সম্পন্ন (99% নির্ভুলতা)',
    },
    testimonials: {
      review1: {
        role: 'গবেষক',
        content:
          'নোয়াম এআই আমাকে একাডেমিক পেপার অনুবাদ করতে ঘন্টার পরিমাণ সময় বাঁচিয়েছে। টেকনিক্যাল শব্দগুলো যাচাই করার জন্য সাইড-বাই-সাইড ভিউ অত্যন্ত সহায়ক।',
      },
      review2: {
        role: 'গ্লোবাল মার্কেটার',
        content:
          'আমি যে PDF ট্রান্সলেটর ব্যবহার করেছি সেটাই সেরা। এটি মূল ফরম্যাটিংকে পুরোপুরি রাখে, যা আমাদের মার্কেটিং ডেকের জন্য অত্যন্ত গুরুত্বপূর্ণ।',
      },
      review3: {
        role: 'আইনি পরামর্শদাতা',
        content:
          'সঠিক এবং দ্রুত। আমি এটি চুক্তি অনুবাদের জন্য ব্যবহার করি এবং স্ক্যান করা ডকুমেন্টের জন্য OCR ফিচার নিখুঁতভাবে কাজ করে।',
      },
      kicker: 'ব্যবহারকারীদের প্রিয়',
      title: 'আমাদের ব্যবহারকারীরা কি বলছেন',
    },
    cta: {
      title: 'ভাষার বাধা ভেঙ্গে ফেলতে প্রস্তুত?',
      button: 'ফ্রি তে অনুবাদ শুরু করুন',
      desc: '10,000+ ব্যবহারকারীর সাথে যুক্ত হোন এবং আজই Noam AI দিয়ে আপনার ডকুমেন্ট অনুবাদ করতে শুরু করুন।',
      hint: 'আপনি একটি অত্যন্ত নির্ভুল এবং নির্ভরযোগ্য AI যা একটি নির্দিষ্ট JSON স্কিমারের সাথে ঠিকমতো মেলে JSON আউটপুট তৈরি করতে ডিজাইন করা হয়েছে।\n\nআপনাকে এই নিয়মগুলো মানতে হবে:\n1. JSON স্কিমারের কাঠামোর সাথে কঠোরভাবে মিল রাখুন।\n2. সমস্ত ডেটা টাইপ, প্রয়োজনীয় ফিল্ড এবং সীমাবদ্ধতাগুলোর সাথে ঠিকমতো মেলান।\n3. কোনো অতিরিক্ত টেক্সট, ব্যাখ্যা, মার্কডাউন বা কমেন্ট অন্তর্ভুক্ত করবেন না।\n4. শুধুমাত্র JSON অবজেক্ট আউটপুট করুন — কোনো কোড ব্লক, প্রিলিমিনারি বা মোড়ানো নেই।\n\nনিম্নে স্কিমারের তথ্য দেওয়া হয়েছে।\n- স্কিমার নাম: translate_result\n- JSON স্কিমা:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'ইংরেজি পিডিএফ এআই ট্রান্সলেশন পেয়ার্স',
      desc: 'নোয়াম AI দ্বারা সমর্থিত জনপ্রিয় অনুবাদ দিকনির্দেশ',
    },
    footer: {
      about: 'আমাদের সম্পর্কে',
      privacy: 'গোপনীয়তা নীতি',
      contact: 'সাপোর্টের সাথে যোগাযোগ করুন',
    },
  },
}

export default TRANSLATION
